import { commaedInteger, formatDigits } from '../scripts/weapp-commons/util/string-util';
/**
 * @generated
 */

export const textEn = {
  c: `100% of the reservation fee`,
  liquidProductsNotice: (className: string) =>
    `Note！ ※if the orders include <span class=${className}>liquid products</span>,Please consider <span class=${className}>having these prizes in your checked baggage</span>.`,
  airports: {
    airportSwitched: `The pick-up location has changed`,
    areYouSureToSwitchAirport: `Are you sure you want to change airport?`,
    map: `Map`,
    mapTitle: (shop: string) => `Pickup location guide for ${shop}`,
    metaDescription: (shop: string) =>
      `Shop at WAmazing Shop and enjoy convenient souvenir shopping at great prices! You can pickup at ${shop}`,
    pickupAirport: `Pickup  Location`,
    selectPickupAirport: `Select Pickup Location`,
    switchingAirportWouldClearCart: `Changing airport will empty your cart.`
  },
  allVisitorCampaign: {
    allYouCanUse: (highlight: string, currency: string) =>
      `<span class=${highlight}><span class=${currency}>JPY </span>1,000 off</span> for everyone!`,
    click: `Click`,
    getCoupon: `Get coupon`,
    getSoon: `Get now`
  },
  amounts: {
    checkVendorAmount: `Please check the total amount per seller`,
    consumptionTax: `Consumption Tax`,
    discounted: `Discount`,
    drugPurchasableAnnotation: `Available when the total amount in the cart at Sugi Drug exceeds 1,000 yen.`,
    explanationOfLocalCurrencyAmount: (date: string) =>
      `*Prices other than Japanese Yen is calculated at the currency rate as of ${date}. \nThe actual amount is determined by the payment service provider.`,
    maximumTotalAmountIs500000JPY: `Max. Amount: JPY500,000`,
    minimalTotalAmountIs1000Jpy: `The minimum purchase amount is JPY 1,000`,
    minimalTotalAmountIs3000Jpy: `The minimum purchase amount is JPY 3,000`,
    minimalTotalAmountIs5000Jpy: `Min. Amount: JPY5,000`,
    orderAmount: `Order Amount`,
    purchaseAmount: `Purchase Amount`,
    shopDiscountAmount: `Admission ticket Discount `,
    subtotalAmount: `Subtotal Amount`,
    taxFree: `Tax Free`,
    taxFreeIfTotalAmountExceeds5kJpy: `Purchases over JPY5,000 will be tax-free.`,
    totalAmount: `Total Amount`
  },
  announce: {
    noteText: `*Due to the year-end and New Year vacations of members in logistics, orders cannot be placed now for those who wish to receive their orders from December 30 to January 7; orders to be delivered from January 8 will be accepted as regular.`
  },
  auth: {
    accountNotYet: `Don't have an account yet?`,
    creditCardList: `My Creditcards`,
    lookForwardToServingYouAgain: `We look forward to serving you again.`,
    signIn: `Log In`,
    signUp: `Sign up`,
    signUpNow: `Register Now`,
    signedOut: `You have been logged out.`,
    signUpCoupon: {
      alt: `JPY500OFF`,
      getNow: `Get now`,
      title: `New Members Get `
    }
  },
  banner: {
    cosmetics: {
      featured: `Featured Collections`,
      mustBuy: `Must-buy Items\nBest Japanese Cosmetics`,
      postCovid: `Post-COVID Essentials`
    },
    skincare: {
      recommended: `Recommendations by the Editorial Team\nPopular Items`,
      specialSet: `Summer Skincare\nSpecial Set`
    },
    snacks: {
      haveATry: `Have a try`,
      souvenirs: `Souvenirs`
    },
    walkthrough: {
      amazingTaxFreeService: `Amazing tax-free service`,
      onlyIn3min: `Only 3 minutes`,
      seeMoreAmazingSights: `See more amazing sights`,
      title: `Reservation online! \nPick up before flying!`
    }
  },
  brands: {
    cosmeticBrand: `Cosmetic Brand`,
    cosmeticBrandTitle: (cosmeticBrand: string) => `Tax-Free ${cosmeticBrand} Items`,
    description: `List of Brands.\nIf you are looking to purchase Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide variety of popular Japanese cosmetics and snacks.`,
    searchResult: `Search Results`,
    titleName: `Brands`,
    viewAll: `View all brands`,
    index: {
      strokeCount: `Strokes`
    },
    list: {
      title: `Brands`
    },
    meta: {
      description: (brand: string) =>
        `List of ${brand} Products. If you are looking to purchase Japanese souvenirs, please visit WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`,
      descriptionWithParams: (brand: string, category: string) =>
        `List of ${brand}'s ${category} Products. If you are looking to purchase Japanese souvenirs, please visit WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`,
      title: (brand: string) => `List of Japanese Tax-Free Products from ${brand}`,
      titleWithParams: (brand: string, category: string) =>
        `List of Japanese Tax-Free Products from ${brand}'s ${category}`
    },
    search: {
      placeholder: `Enter brand name here`
    },
    slug: {
      description: (brand: string) =>
        `List of ${brand} Products. If you are looking to purchase Japanese souvenirs, please visit WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`
    }
  },
  campaign: {
    present: `Gift`,
    bank: {
      esun: `TODO: campaign.bank.esun@en`,
      taiwanMobile: `TODO: campaign.bank.taiwanMobile@en`,
      title: `We’re currently offering a variety of exciting campaigns! Check them out here!`,
      ubot: (price: string, discount: string) => `TODO: campaign.bank.ubot@en`,
      yuanta: `TODO: campaign.bank.yuanta@en`
    },
    fancl: {
      addNowToCart: `Add now to your cart`,
      goodDealPrice: (price1: string, price2: string) =>
        `Save JPY ${price2} off the regular price of JPY ${price1} (tax included)`,
      limitedSpecialSet: `FANCL Limited Special Set`,
      specialSetPrice: `Special set price`,
      usageStep: `Steps`,
      brighteningSet: {
        present: `＜Gift＞Mild Cleansing Oil (120ml)`,
        product1: `・Mild Cleansing Oil -Black & Smooth- 120ml`,
        product2: `・Clay Gel Facial Wash 120g`,
        product3: `・Brightening Lotion II 30ml`,
        product4: `・Brightening Essence 18ml`,
        product5: `・Brightening Emulsion II 30ml`,
        product6: `・Brightening Facial Mask (6 pieces)`,
        product7: `・Sunguard 50+ Protect UV (60ml)`,
        title: `Brightening Set`,
        whatMelanin: `※1 Brightening means suppressing melanin production and preventing spots and freckles.\n(Excluding Mild Cleansing Oil, Clay Gel Facial Wash, and Sunguard 50+ Protect UV)`
      },
      og: {
        description: `WAmazing Exclusive FANCL limited quantity special skincare sets! The WAmazing Shop is the best place to buy  souvenirs easily and at great prices!`,
        title: `WAmazing Exclusive FANCL limited quantity special skincare sets! | WAmazing Shop`
      },
      pores: {
        present: {
          description: `Instantly dissolves and removes the most stubborn makeup and pore-clogging dirt and oil.`,
          name: `Cleansing`,
          title: `Mild Cleansing Oil (60ml)`
        },
        step1: {
          description: `This powdery enzyme facial cleanser cleans any impurities from pores.`,
          name: `Face Wash`,
          title: `Deep Clear Washing Powder 30pcs`
        },
        step2: {
          description: `You don't need to peel it off, just rinse. Clears blackheads in just 5 minutes!`,
          name: `Cleansing`,
          title: `Pore Cleansing Pack　40g`
        },
        step3: {
          description: `This serum targets the cause of worrisome pores. This targeted serum prevents shine and leaves skin smooth.`,
          name: `Pore Essence`,
          title: `Pore Essence 8g`
        },
        step4: {
          description: `Facial wash for daily use to cleanse pores from any impurities.`,
          name: `Face Wash`,
          title: `Clay Gel Facial Wash 120g`
        },
        step5: {
          description: `Instantly dissolves and removes the most stubborn makeup and pore-clogging dirt and oil.`,
          name: `Cleansing`,
          title: `Mild Cleansing Oil (120ml)`
        },
        step6: {
          description: `Perfect for those who are concerned about buildup on their nose, want to have smoother skin, or just want to care for their pores!`,
          name: `Cleansing`,
          title: `Mild Cleansing Oil -Black & Smooth- 120ml`
        }
      },
      poresSet: {
        present: `＜Gift＞Mild Cleansing Oil (60ml)`,
        product1: `・Deep Clear Washing Powder 30pcs`,
        product2: `・Pore Cleansing Pack　40g`,
        product3: `・Pore Essence 8g`,
        product4: `・Clay Gel Facial Wash 120g`,
        product5: `・Mild Cleansing Oil (120ml)`,
        product6: `・Mild Cleansing Oil -Black & Smooth- 120ml`,
        title: `Pore Care Set`
      },
      present: {
        description: `Instantly dissolves and removes the most stubborn makeup and pore-clogging dirt and oil.`,
        name: `Cleansing`,
        title: `Mild Cleansing Oil (120ml)`
      },
      step1: {
        description: `Perfect for those who are concerned about buildup on their nose, want to have smoother skin, or just want to care for their pores!`,
        name: `Cleansing`,
        title: `Mild Cleansing Oil -Black & Smooth- 120ml`
      },
      step2: {
        description: `Facial wash for daily use to cleanse pores from any impurities.`,
        name: `Face Wash`,
        title: `Clay Gel Facial Wash 120g`
      },
      step3: {
        description: `This moisturizing, medicated brightening lotion gives a healthy and clear complexion.`,
        name: `Lotion`,
        title: `Brightening Lotion II 30ml`
      },
      step4: {
        description: `This serum treats the root of blemishes for clear, beautiful skin.`,
        name: `Essence`,
        title: `Brightening Essence 18ml`
      },
      step5: {
        description: `This moisturizing medicated brightening emulsion gives clear, beautiful skin with lasting moisture.`,
        name: `Emulsion`,
        title: `Brightening Emulsion II 30ml`
      },
      step6: {
        description: `Each mask contains more than one whole bottle of brightening essence.`,
        name: `Facial Mask`,
        title: `Brightening Facial Mask (6 pieces)`
      },
      step7: {
        description: `Resistant to sweat and water, blocking the skin from strong UV rays and external stimuli!`,
        name: `Sunscreen`,
        title: `Sunguard 50+ Protect UV (60ml)`
      }
    },
    jcb: {
      aboutFlow1: `Complete your purchasereservation<br>via the web or app <em>at least 3 days prior</em><br><em>to the desired pick-up date</em>`,
      aboutFlow2: `<em>The process takes about 3 minutes! </em><br>At the locker, with facial recognition<br>and your passport, tax free processing<br>and payment is complete!`,
      aboutFlow3: `Pick-up of purchased items<br>at the <em>locker</em> is complete.`,
      aboutNote: `（pick-up locations can be selected from airports\nand train stations nationwide）`,
      aboutText: `A tax-free online shopping service that allows customers to use<br><em>the locker-type vending machines</em>installed in train stations and airports<br>throughout Japan to pick up the purchased products.`,
      flow1: `After adding <em>JPY 10,000<sup>※</sup> or more</em> of products to your cart, press <em>the cart button</em> to go to the payment screen.`,
      flow2: `Click on "<em>Select Coupon</em>" where the order amount is listed and enter/select the above code.`,
      flow3: `Select "<em>JCB</em>" on the next payment page to complete your purchase reservation.`,
      meta: `JCB members exclusive plan! JPY 2,000 off tax-free items for purchases of JPY 10,000 or more!`,
      noteForCondition: `*Price before discount　\n*Some items are not eligible for discounts`,
      noteForFlow: `*A minimum purchase of JPY 10,000 of discount-eligible items is required`,
      period: `From October 16, 2023 to January 15, 2024 (until 11:59 PM Japanese time)`,
      shoppingTitle: `The perfect foodie gift for the end of year!`,
      banner: {
        notice: `※Not eligible for the JCB coupon`,
        title: `WAmazing Other services`
      },
      notes: {
        note1: `- All JCB cards are eligible except those issued in Japan and Hong Kong.`,
        note10: `- By participating in this campaign, you agree to provide your personal information to WAmazing inc. and JCB International Inc.`,
        note2: `- Payment must be made with a JCB card.`,
        note3: `- Coupon can be used only once per person.`,
        note4: `- Coupons cannot be combined.`,
        note5: `- Coupon expires at 11:59 PM Japan time, on January 15, 2024.`,
        note6: `- The rights to this campaign may not be transferred to another person or exchanged for cash.`,
        note7: `- This campaign is subject to change or end without notice.`,
        note8: `- Some products are not eligible for this campaign.`,
        note9: `- The campaign period corresponds to the timeframe designated for the campaign's execution as indicated at the time of this information's publication.\nThis campaign may be continued after the above period.`
      },
      shopping: {
        brandTitle153: `〈Official product〉SHISEIDO`,
        brandTitle426: `〈Official product〉SKⅡ`,
        brandTitle7558: `KAMEDA no Kaki no Tane`,
        brandTitle8472: `Setouchi Lemon Farm`,
        brandTitle9422: `Okinawa Nanpudo`,
        brandTitle9516: `Iwateya`,
        brandTitle9538: `〈Official product〉FANCL`,
        brandTitle9597: `〈Official product〉KOSE `,
        catch153: `Super Popular Anti-aging Care`,
        catch426: `SK-II Best Seller`,
        catch6842: `Hokkaido Brand`,
        catch6937: `No. 1 Popular Gift`,
        catch7534: `Sold out in many stores`,
        catch7558: `Tokyo Exclusive`,
        catch7696: `Crown melon with pulp`,
        catch8472: `Grown in Hiroshima, Japan's No.1\nlemon producer`,
        catch9422: `Okinawa / Addicting Spiciness`,
        catch9516: `Iwate Confectionery`,
        catch9538: `Amazing Limited Edition\nAuthentic Products`,
        catch9597: `Awarded No. 1 Best Cosmetics`,
        description153: `A beauty dense cream that fills the skin with moisture and elasticity. Spreads and fits to the skin without being sticky.`,
        description426: `SK-II's best-selling whitening serum effectively combats the appearance of spots and dullness resulting from UV damage, granting your skin an inner radiance and luminosity.`,
        description6842: `The six varieties include "High Milk," meticulously crafted with milk sourced from Hokkaido, and "Matcha Milk," a collaborative creation featuring matcha from Nishio—a region renowned for its exceptional matcha green tea.`,
        description6937: `These miniature individual packets come in five different flavors, making them the perfect souvenir!`,
        description7534: `Cheese confectionery supervised by professionals who know cheese inside and out, with a focus on taste, aroma, and texture.`,
        description7558: `Kaki-no-tane assortment containing 4 bags each of sweet and spicy tempura rice bowl flavor, monjayaki flavor, rich demi-glace flavor and dashi curry flavor`,
        description7696: `A jelly and pudding set featuring the pulp of the finest crown melon among all melon varieties.`,
        description8472: `Crispy on the outside and soft and fluffy on the inside. The refreshing lemon flavor, which is not too sweet, makes it a good choice for tea time.`,
        description9422: `The spiciness is irresistible. Crispy shrimp crackers with Okinawan island chili peppers`,
        description9516: `While based on the simple taste of wheat, sesame, and a little saltiness, the Nanbu senbei reveals a variety of flavors depending on the combination of ingredients.`,
        description9538: `A 5-piece set of recommended cleansers and serums for pore-less skin. Plus, now you can get a bottle of cleansing oil as a free gift!`,
        description9597: `Recipient of numerous "Best Cosmetics No.1" awards! This reparative cream aids your skin in appearing as if you've enjoyed an additional 3 hours of sleep, even during periods of sleep deprivation.`,
        moreButton1: `Souvenirs recommended by our editors`,
        moreButton2: `See more souvenirs from all over Japan`,
        moreButton3: `See More Recommended Products`,
        notice: `※Calculations are based on the exchange rate as of the end of August 2023. The actual purchase amount will be based on the exchange rate at the time of purchase.`,
        sectionTitle1: `The perfect foodie gift for the end of year!`,
        sectionTitle2: `Japanese favorites! Souvenirs only available regionally`,
        sectionTitle3: `Now is the time to buy products at a great price`,
        text153: `ELIXIR Lift Night Cream W`,
        text426: `GenOptics Aura Essence Serum 30ml`,
        text6842: `LANGUE DE CHAT Assortment 30 pieces`,
        text6937: `GIFT BOX MINI 10-Pack`,
        text7534: `NEW YORK PERFECT CHEESE　12PCS`,
        text7558: `Tokyo Exclusive KAMEDA's Souvenir Kaki no Tane`,
        text7696: `CROWN MUSK MELON DESSERT, 8pcs. (with 3 special golden spoons)`,
        text8472: `Ginsu Lemon Lemon Sponge Cake 80g`,
        text9422: `Shimatogarashi Ebi Senbei Crackers (Small)`,
        text9516: `Niko Niko Nanbu Senbei Crackers`,
        text9538: `Pore Care Set`,
        text9597: `Liposome Advanced Repair Cream 50g`
      }
    }
  },
  cart: {
    addToCart: `Add To Cart`,
    addedToCart: `Added to Cart`,
    cartCollections: `Cart Collections`,
    cartIsEmpty: `Your Cart Is Empty`,
    cartIsEmptyToTop: `Return to TOP`,
    cartIsEmptyToTopAndAddProducts: `Return to TOP\nAdd your favorite products.`,
    continueShopping: `Continue Shopping`,
    detail: `Amount  Detail`,
    insufficientAmountToPurchase: (insufficientAmount: number) =>
      `Please add JPY ${insufficientAmount} to your total to qualify`,
    proceedToForm: `Proceed to order`,
    purchasable: `Purchasable`,
    showToCart: `View Cart`,
    taxFreeShopOrderingCondition: (shopName: string) =>
      `A minimum purchase of JPY 5000(after discount) is required for ${shopName}`,
    taxableShopOrderingCondition: (shopName: string) => `A minimum purchase of JPY 1000 is required for ${shopName}`,
    title: `Cart Detail`,
    agree: {
      addToCart: `Agree and add to cart`
    },
    cannotPickup: {
      removeItem: `Can not pick-up\nPlease removed this item`
    },
    confirm: {
      addToCart: `Confirm and add to Cart`,
      checkNotes: {
        addToCart: `Check the precautions and add to cart`
      }
    }
  },
  cartError: {
    productNotOrderable: `The item is not ready`
  },
  category: {
    largeCategoryDescription: (largeCategory: string) =>
      `Buy the best Japanese ${largeCategory} online and pick them up at the airport in Japan. Shop at WAmazing Shop and enjoy convenient souvenir shopping at great prices! `,
    middleCategoryDescription: (middleCategory: string, largeCategory: string) =>
      `Buy the best Japanese ${middleCategory} ${largeCategory} online and pick them up at the airport in Japan. Shop at WAmazing Shop and enjoy convenient souvenir shopping at great prices! `,
    middleCategoryMetaTitle: (middleCategory: string, largeCategory: string) =>
      `Best Japanese ${middleCategory}・${largeCategory}`,
    popularSmallCategory: `Popular small category`,
    showVendorOnlyDrug: `Sugi Pharmacy Kawaguchi Tozuka Store`,
    smallCategoryDescription: (smallCategory: string, middleCategory: string) =>
      `Buy the best Japanese ${smallCategory} ${middleCategory} online and pick them up at the airport in Japan. Shop at WAmazing Shop and enjoy convenient souvenir shopping at great prices! `,
    smallCategoryMetaTitle: (smallCategory: string, middleCategory: string) =>
      `Best Japanese ${smallCategory}・${middleCategory}`,
    title: `Category`,
    meta: {
      description: (categoryName: string) =>
        `If you are looking to purchase ${categoryName} Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`,
      title: (categoryName: string) => `List of Japanese Tax-Free Items in ${categoryName}`
    }
  },
  categoryRanking: {
    seeMore: `See More`,
    title: `Ranking by Category`
  },
  commons: {
    after: (time: string) => `after ${time} (Japan time)`,
    afterShipping: `After shipping`,
    all: `All`,
    autoApplyDiscountOnAddToCart: `Automatically applied in cart.`,
    autoApplyDiscountOnAddToCartDesc: `Automatically applied in cart. Can be used in conjunction with other coupons`,
    automaticCancel: (time: string) => `Automatic cancellation past ${time}(Japan time)`,
    before: `Before`,
    beforeShipping: `Before shipping`,
    bestJapanese: `Best Japanese `,
    cancelFee: `cancel fee`,
    choice: `Select`,
    cosmetics: `Skincare, cosmetics`,
    dateAndTime: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${month} ${day}, ${year},  ${hour}:${minute}`,
    dismiss: `Close`,
    download: `DL`,
    errorOccurred: `An Error Has Occurred`,
    exclamationMark: `!`,
    foldContents: `Hide contents`,
    goBack: ` Back`,
    hot: `HOT`,
    lessThan: `or less`,
    mustBuy: `Must-buy `,
    noShow: `No-show without cancellation`,
    ok: `OK`,
    pinchOut: `Pinch out to zoom`,
    proceed: `Proceed`,
    purchaseTaxFree: `Purchase tax-free`,
    qualities: `Qualities`,
    quantity: `Quantity`,
    remove: `Remove`,
    showMore: `See More `,
    showMoreDetails: `See more details`,
    signUp: `Register`,
    snacks: `Snacks`,
    specialDeals: `Deals`,
    tax: `Tax`,
    taxFreeProducts: `Tax-Free Products`,
    taxFreeRegularPrice: `Regular Price (Tax-free)`,
    taxFreeSalePrice: `Sale Price (Tax-free)`,
    taxProducts: `Taxable products`,
    topPage: `Top Page`,
    tryAgain: `Please try again from the beginning.`,
    undisclosed: `Undisclosed`,
    until: (time: string) => `until ${time} (Japan time)`,
    vendor: `Seller`,
    wamazingShop: `WAmazing Shop`,
    yen: `JPY`,
    aboutWamazingShop: {
      desc: `Our locker-type vending machines installed in train stations and airports throughout Japan allow customers to pick up tax-free purchases before returning home.`,
      title: `About the WAmazing Shop`
    },
    campaign: {
      seeMoreDetail: `See more details about campaign`
    },
    date: {
      day: `Day`,
      month: `Month`,
      year: `Year`
    },
    meta: {
      title: `Choose WAmazing Shop if you want to buy Japanese souvenirs tax-free and easily during your trip to Japan｜WAmazing Shop`
    },
    notice: {
      notContainKobayashiPharmaceuticalBeniKoji: `The products sold through WAmazing do not contain any of Kobayashi Pharmaceutical's "beni koji" (red yeast rice), which has been reported to be hazardous to health.`
    },
    url: {
      copied: `URL copied`
    }
  },
  complementary: {
    addNToCart: (count: number) => `Add ${count} items to cart`,
    addToCart: `Add to cart`,
    count: (count: number) => `Subtotal ${count}`,
    title: `Ex: Product Taste, Usability`,
    viewDetail: `Check details`
  },
  counterPickup: {
    jttpRemark: `WAmazing Shop is currently not compatible with JTTP.`,
    vjmGuideUrl: `https://services.digital.go.jp/en/visit-japan-web/guide/`,
    vjmRemark: (className: string, childClassName: string, url: string) =>
      `To receive your items tax-free at designated facilities, <span class=${className}>you <a class=${childClassName} href=${url} target="_blank">must register for VJW (Visit Japan Web)</a></span> after entering Japan.`,
    guide: {
      cancellationPolicy: {
        description: `A cancellation fee of 20% of the purchase price paid at the time of reservation will be charged. For in-person pickups, 80% will be refunded at the time of cancellation as 100% payment was made at the time of reservation.`,
        refund: {
          description: `If a refund is due, it will be issued immediately upon cancellation. Depending on the payment method used, it may take some time for the refund to actually be issued. Refunds are tied to the payment method used.`
        }
      },
      caution: {
        text1: `Make sure \nAirport is correct`,
        text2: `Check the \nPickup date`,
        text3: `Please do not forget to bring your passport when collecting your items from a locker`,
        text4: `Ensure that you have \nInternet access for pickup`,
        title: `Points to note:`
      },
      counter: {
        help: {
          description: `Customer service representatives are available to assist you.`,
          descriptionDetail: (className: string) =>
            `If you have any problems receiving your order, please contact WAmazing customer support by using the inquiry <span class=${className}>QR code</span> presented to you by our staff or by checking our website (https://www.wamazing.com/kaimono/pickup_support).`,
          title: `If you are having trouble with in-person pickup...`
        },
        step1: {
          description1: (className: string) =>
            `In order to complete the tax exemption procedures for in-person pickup, you will need to <span class=${className}>register</span> on the Visit Japan Web site and <span class=${className}>create a tax-free QR code</span> in advance.`,
          description2: `What is Visit Japan Web?`,
          description3: `See the Visit Japan Web usage procedures`,
          title: `Register with Visit Japan Web (VJW) before entering Japan`
        },
        step2: {
          description: (className: string) =>
            `Specify <span class=${className}>location</span>, <span class=${className}>date</span>, and <span class=${className}>time</span> of pickup`,
          title: `Select a pickup location`,
          button: {
            title: `List of in-person pickup locations`
          }
        },
        step3: {
          description1: `Please issue a Tax-Free Shopping QR Code before pickup`,
          title: `Generate a Tax-Free Shopping QR Code on Visit Japan Web`,
          button: {
            title: `How to generate a Tax-Free Shopping QR Code`
          }
        },
        step4: {
          description: (className: string) =>
            `Present your Pickup QR Code and Tax-Free Shopping QR Code issued in Step 3 to the staff when you pick up the product.\nYou can check your Pickup QR Code from your purchase history on My Page. Please contact WAmazing <span class=${className}>customer support</span>, not our local staff, if you have any questions.`,
          title: `Receiving your items\n`
        }
      },
      customerSupport: {
        description: `If you are unable to collect your purchase due to unforeseen problems, etc., we will refund the full amount. Please contact customer support for more details. *Cancellation by the customer is not allowed. In case of delay by public transportation, a refund will be issued upon presentation of a certificate of delay.`,
        heading: `Information about the money back guarantee`,
        subHeading: `Easy even for first-time visitors`,
        title: `In the unlikely event that you cannot collect your purchase, you will receive a full refund!`
      },
      faq: {
        message1: `What do I need to bring when picking up my order?`,
        message10: `All of our lockers are located within train stations and airport premises.\nPickup must be completed before passing through security checks (before departure).\nWe recommend retrieving your items from the lockers before check-in.\n\n*If picking up upon arrival, you can collect your items after immigration.\n*If your purchase includes liquids over 100ml, we recommend packing them in your checked luggage (rather than carry-on baggage.)\n\nFor detailed information on pickup locations and procedures, please visit:\n<a href="https://www.wamazing.com/kaimono/guide">https://www.wamazing.com/kaimono/guide</a>\n*A passport with an IC chip and a valid entry permit stamp are required for pickup.`,
        message11: `I made my payment at the locker to retrieve my items, but they aren't in the locker. What should I do?`,
        message12: `We apologize for the inconvenience. Please contact our customer support team for a full refund or to have the product shipped to your home.\n<a href="https://www.wamazing.com/kaimono/support ">https://www.wamazing.com/kaimono/support </a>`,
        message2: `Locker Pickup:\nFacial recognition and identity verification are required. Please bring the following items:\n\n(1) Recipient’s Passport with IC Chip\nThe passport must belong to the recipient. (Someone else’s passport cannot be used.) If your passport does not contain an IC chip, pickup will not be possible.\n\n(2) Landing Permit\n*Affixed to your passport upon entry to Japan.\n*This service is not available to cabin attendants, transit passengers, or individuals with a Japanese visa status who did not receive a landing permit stamp upon entry (including JTTP holders).\n\n(3) Internet-Enabled Mobile Phone\nPlease be sure to bring a cell phone that can connect to the Internet, as internet access is required for payment.\n\nIn-Person Pickup:\n(1) Visit Japan Web's Tax Free Shopping QR Code\nPlease generate a Tax-Free Shopping QR Code in advance:\nhttps://services.digital.go.jp/visit-japan-web/guide\n\n(2) Internet-Enabled Mobile Phone\nA mobile phone with internet access is required when collecting your items.`,
        message3: `What should I do if I miss my reserved pickup time?`,
        message4: `If you miss your reserved pickup time, your order will be canceled. Please note that a cancellation fee will apply, and you will not be able to retrieve your items.`,
        message5: `Is it possible to retrieve my items before the reserved pickup time?`,
        message6: `No, it is not possible to retrieve the items before the reserved pickup time.`,
        message7: `Can I pick up my items on a day other than my departure date?`,
        message8: `You can pick up your items anytime during your stay in Japan. However, please make sure to adhere to the selected pickup date and time.`,
        message9: `Where are the pickup lockers located? Are they before customs? In the departure area?\n`,
        title: `Frequently asked questions (FAQ)`
      },
      locker: {
        step1: {
          description: (className: string) =>
            `Easily collect your items from unmanned lockers at <span class=${className}>airports, train stations, and bus terminals</span> across Japan.`,
          title: `Pickup location selection`
        },
        step2: {
          description: (className: string) =>
            `At the lockers, enter the <span class=${className}>4-digit code</span> displayed on the locker tablet into <span class=${className}>Payment Procedures</span> on the <span class=${className}>Reservation Details</span> page.`,
          title: `Confirm the QR code`
        },
        step3: {
          description1: (className: string) => `*Your passport must be an <span class=${className}>e-passport</span>.`,
          description2: `You must bring your e-passport with you to verify your identity.`,
          title: `Confirm your passport`
        },
        step4: {
          description: `In front of the locker, on the Purchase History page, press the "Enter 4-digit number" button and enter the 4-digit number that is displayed on the locker tablet.`,
          title: `Payment when you pickup your shopping`
        },
        step5: {
          description: (className: string) =>
            `Please follow the instructions on the locker tablet to <span class=${className}>pick up your items.</span>`,
          title: `Receiving your items\n`
        }
      },
      pickup: {
        title: `Pickup Location`
      },
      table: {
        title: `Difference between locker and in-person pickup`,
        row1: {
          column1: `Unstaffed`,
          column2: `Staff present`,
          header: `Staff Availability`
        },
        row2: {
          column1: `• At reservation: 20%\n• Upon pickup: 80%`,
          column2: `• At reservation: 100%\n• Upon pickup: -`,
          header: `Payment method`
        },
        row3: {
          column1: `Necessary`,
          column2: `Not necessary`,
          header: `VJW Registration`
        },
        row4: {
          column1: `• Passport with IC chip\n• Landing permit`,
          column2: `• VJW Tax Exemption QR Code`,
          header: `What you need for pickup`
        },
        row5: {
          column1: `Unavailable`,
          header: `JTTP`
        }
      }
    }
  },
  coupons: {
    acquired: `Coupon obtained`,
    allYouCanUse: (highlight: string) => `<span class=${highlight}>Coupons</span> for everyone!`,
    allYouCanUseText: `Coupons for everyone!`,
    canBeUsedForJcb: `*The coupon you selected can only be used with JCB cards. Please change your card or delete/select a different coupon.`,
    canBeUsedForWamazingProducts: `*Coupons can only be applied for WAmazing products`,
    consumableLimitReached: `Already Claimed`,
    coupon: `Coupon`,
    couponForEveryone: `Coupon for everyone`,
    discountByAmount: (amount: number) => `JPY${amount} Off`,
    discountByRate: (rate: number) => `Discount ${formatDigits(100 * rate)}%`,
    discountLimit: (discountLimit: number) => `up to JPY ${discountLimit} off`,
    minSettlementAmountRemark: (minSettleMent: number) =>
      `Only available for orders of JPY ${commaedInteger(
        minSettleMent
      )} and above before discount. *You cannot complete the purchase when the payment amount is under JPY 5,000, as it does not meet tax exemption requirements.\n`,
    noCouponToUse: `No Available Coupons`,
    noMedsAlcohol: `Medicines and alcoholic beverages are not eligible for this discount.`,
    notLogin: `You can register your coupon after logging in`,
    notUseCoupon: `Do not use coupon`,
    note: `Notes`,
    pickCoupon: `Select Coupon`,
    pleaseReview: `This coupon cannot be used. Please review the coupon's terms and conditions before use.`,
    terms: `Terms`,
    usableBeforeJst: `Valid until (JST)`,
    usePromoCode: `Enter Coupon Code`,
    discount: {
      limit: (amount: number) => `The maximum discount for this coupon is JPY ${amount}.`
    },
    list: {
      pleaseLogin: `To get the coupon, please log in first.`,
      title: `coupons`,
      page: {
        description: `The WAmazing Tax-Free Online Shop is the best place to buy local souvenirs from all over Japan! Purchase souvenirs from your trip to Japan easily and at great prices!`,
        title: `Coupons｜WAmazing Shop`
      }
    }
  },
  creditCard: {
    error: {
      identityAuthentication: `Identity authentication of your credit card has failed.`,
      useAnotherCard: `Please use another credit card.`
    }
  },
  crossSelling: {
    activity: {
      title: `Itineraries for popular activities in Tokyo`
    },
    tickets: {
      title: `Getting around Tokyo & discount transportation tickets`
    }
  },
  customerSupport: {
    chat: `Inquire via chat support`,
    description: `Frequently Asked Questions\nIf you are interested in purchasing Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We offer a wide variety of popular Japanese cosmetics and confectionery.`,
    title: `Customer Support`
  },
  discountNotice: {
    addToCart: (rate: number) => `A ${rate}% discount has been applied to the cart.`,
    description: `The discount will be automatically applied when the item is added to the cart.\nIt can also be combined with other coupons.`,
    mainText: (className: string, rate: number) =>
      `This product is <span class=${className}>eligible for a ${rate}% discount</span>`
  },
  favorites: {
    addSelectedToCart: `Add to Cart`,
    addToFavorite: `Add to Wishlist`,
    addedToFavorite: `This item has been added`,
    isEmpty: `No items in your Wishlist`,
    notLogin: `To use the "Favorite" function, please log in.`,
    removeSelectedFromFav: `Delete from Wishlist`,
    title: `Wishlist`
  },
  featured: {
    featuredCollections: `Featured Collections`,
    keywords: `Featured Keywords`,
    moreFeaturedCollections: `More Featured Collections`,
    popularCosmeticSets: `WAmazing Exclusive Popular Cosmetic Sets`,
    recommendedFeaturedCollections: `Recommended Featured Collections`,
    recommendedProducts: (largeCategoryName: string) => `Recommended popular ${largeCategoryName}`,
    shiseidoBestHit2023: `SHISEIDO Best Hit Cosme 2023`,
    antiUVCosmeticsLP: {
      description: `Where can I find these popular cosmetics? You can pre-order the latest UV-protection products at tax-free prices. We offer a selection of popular brands like ANESSA, Clé de Peau Beauté, POLA, and SK-II. We'll introduce cosmetics our buyers highly recommend.`,
      title: `Must buy cosmetics against UV rays in Japan`,
      addToCartNow: {
        title: `Add to cart now`
      },
      buyerComment: {
        title: `Buyer's Comments`
      },
      buyerRecommendation: {
        comment: `For the upcoming season, we recommend CPB's skin care set, which protects you from external stresses such as UV rays and dryness and brings out your radiance.\nCPB, which brings together the world's leading technologies, is a very popular brand that users never stop raving about.`,
        title: `Recommended by WAmazing buyers! \nSummer Skin Set `,
        product: {
          content: `Clé de Peau Beauté Hydro-Softening Lotion 170 ml\nClé de Peau Beauté Protective Fortifying Emulsion 125 ml\nClé de Peau Beauté The Serum 50 ml`,
          title: `[5% OFF] Clé de Peau Beauté Recommended Summer Set`
        }
      },
      contentDesc: {
        setTitle: `Set Contents`,
        title: `Features`
      },
      featuredCosmeticPrimer: {
        comment: `Achieve beautiful skin with a simple one-step process that provides both UV protection and acts as a makeup primer.`,
        title: `Popular makeup bases in 2024`,
        product: {
          content: `防晒、提亮、润色一步到位的防晒BB霜。\n不添加化学处方，拥有全日本最高等级的防紫外线保护。`,
          title: `THREE スムースオペレーターハイパフォーマンスクリーム 01`
        }
      },
      featuredSunscreen: {
        comment: `ANESSA Gold is perfect for those who want to avoid getting sunburned!\nDespite being a milky type, it has a smooth, light texture that spreads easily on the skin, and\nit does not feel heavy like a typical sunscreen.\nIt doubles as a makeup primer, making it ideal for everyday use.\nIt's waterproof, making it perfect for sports and leisure activities! Plus, it's easy to remove with soap, which is a great bonus.`,
        title: `Basics of UV protection! \nSunscreens to watch in 2024`,
        product: {
          content: `Long-lasting moisturization\nWaterproof\nRemove with soap\nFloral fragrance`,
          title: `ANESSA`
        }
      },
      recommendationRate: {
        title: `Recommendation Rating`
      },
      sale: {
        setTitle: `Special set price`,
        title: `Special price`
      },
      saleText: {
        title: (currency: string, preDiscountPrice: number, discountAmount: number, className: string) =>
          `Usually priced at ${currency}<span class=${className}>${preDiscountPrice}</span> (tax included), now available at ${currency}<span class=${className}>${discountAmount}</span> off`
      }
    },
    anti_aging: {
      short_desc: `Recommended Japanese skincare and cosmetics for anti-aging and wrinkles`,
      title: `Anti-aging/Wrinkles`
    },
    beautyAppliances: {
      subTitle: `We have gathered a selection of beauty appliances made in Japan, perfect as a treat for yourself.`,
      title: `Cutting-edge beauty appliances`
    },
    buyersChoiceFood: {
      subTitle: `We have collected products recommended by WAmazing buyers with extensive knowledge of Japan.`,
      title: `Buyer's choice (food)`
    },
    coldSake: {
      subTitle: `We've curated a selection of delicious cold sake that are ideal for the hot season.`,
      title: `Cold sake recommendations`
    },
    collagen: {
      short_desc: `Recommended Japanese products, cosmetics and supplements containing collagen`,
      title: `Collagen Products`
    },
    drug: {
      adBanner: {
        title: `Must buy in Japan Drugs`
      }
    },
    drug_store: {
      short_desc: `Cosmetics and snacks from Japanese drugstores`,
      title: `Drugstore Items`
    },
    facialCleansers: {
      subTitle: `Transform your skin with every wash. Explore our selection of recommended facial cleansers.`,
      title: `Popular facial cleansers in Japan`
    },
    gift: {
      subTitle: `We have gathered a selection of unique Japanese gifts.`,
      title: `Feature on Japanese gifts, ideal for gifting purposes`
    },
    index: {
      meta: {
        description: `A featured list of bargain products and seasonal recommendations. If you are interested in purchasing Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We offer a wide selection of popular Japanese cosmetics and snacks.`
      }
    },
    japaneseTraditionalSweetAndSnacks: {
      subTitle: `We've gathered various popular Japanese sweets from all over Japan. `,
      title: `Wagashi is a Japanese tradition`
    },
    limitedSale: {
      caveat: `Please wait as we are currently preparing products.`,
      expirationConfirm: `■ Please check the following description before purchasing.`,
      expirationDate: (year: string, month: string, day: string, className: string) =>
        `This product is available for purchase with a limited pickup date.\nIt will not be sold</span> after <span class=${className}>「${year}/${month}/${day}」, so the pickup date must be set before the above-mentioned date.`,
      title: `limited-time sale`
    },
    lotion: {
      bestLotionsToBuyInJapan: `The best lotions to buy in Japan `,
      description: `WAmazing Editor's Choice! The best lotions to buy in Japan |  Shop at WAmazing  Shop and enjoy convenient souvenir shopping at great prices! `,
      leadSentence: `It's been a while since your last trip, and the yen is weak! Now is the perfect time to go shopping!\nWe'll be introducing "Cosmetics that Make Great Gifts ～Lotion Edition～" as selected by WAmazing's editorial staff. This time we present our editor's choice for the best basic lotion. If you're thinking of a gift for a friend, family member, or even a treat for yourself, please take a look!\nSome products are only available in Japan, so make sure not to miss them!\n・The following are personal opinions`,
      otherLotions: `Other Lotions`,
      wamazingEditorChoice: `WAmazing Editor's Choice`,
      elixir: {
        description: `Another highly recommended product that has not yet been released overseas! Its new packaging is more minimalist than before and will be loved by people in their 20s to 40s. This is the thickest lotion of them all, and its floral scent is soothing.`,
        title: (className: string) =>
          `Updated in September 2022! <span class=${className}>Elixir Superieur Lifting Moisture Lotion</span>`
      },
      haku: {
        description: `We highly recommend this product if you want to brighten your skin. It contains skin-brightening active ingredients and has a thick texture. It is moisturizing yet sits comfortably on the skin and has a subtle fragrance.`,
        title: (className: string) => `<span class=${className}>HAKU</span> is the Best Brightening Lotion`
      },
      obagi: {
        description: `We recommend this as a souvenir for slightly older family members. It is highly acclaimed in Japan for its anti-aging properties. It is highly moisturizing, and the thick lotion permeates into the skin. The citrus scent is refreshing. It is expensive, but with the weak yen, now is a perfect time to buy!`,
        title: (className: string) => `The Highly Moisturizing <span class=${className}>Obagi X</span>`
      },
      orbis: {
        description: `ORBIS U, one of Orbis' most popular products, has been updated. This product is not sold overseas, so it will make your friends happy. The lotion has a thick texture and is moisturizing. The updated bottle has a triangular cutout on the lid, giving it a stylish design.`,
        title: (className: string) => `Only Available in Japan!\nThe Updated <span class=${className}>ORBIS U</span>`
      }
    },
    meta: {
      common: {
        description: `Visit the WAmazing Shop to purchase your Japanese souvenirs. Purchased items can be picked up at designated airports during your trip to Japan. We offer a wide variety of popular Japanese cosmetics and confectionery.`
      }
    },
    mtFuji: {
      subTitle: `When it comes to Japanese souvenirs, look no further! We have a collection of cute Mt. Fuji items.`,
      title: `Fuji Goods Special Collection`
    },
    nibbles: {
      subTitle: `A selection of Japanese snacks`,
      title: `Japanese snacks that pair well with alcohol!`
    },
    pickUp: {
      title: `Featured Items`
    },
    quickShip: {
      shopNow: `Shop now`,
      title: `Our fastest delivery products`
    },
    sensitive_skin: {
      short_desc: `Recommended Japanese skincare and cosmetics for sensitive skin`,
      title: `Sensitive Skin`
    },
    serums: {
      subTitle: `We have a range of high-quality beauty serums from Japanese manufacturers.`,
      title: `High-quality beauty serums from Japan`
    },
    shoppingArticle: {
      title: `Shopping Articles`
    },
    skin_whiten: {
      short_desc: `Recommended Japanese brands for beautiful skin`,
      title: `Beautiful Skin/Spots`
    },
    slug: {
      meta: {
        description: `Visit the WAmazing Shop to purchase your Japanese souvenirs. Purchased items can be picked up at designated airports during your trip to Japan. We offer a wide variety of popular Japanese cosmetics and confectionery.`
      }
    },
    summer2023: {
      naviTitle: `Summer 2023 seasonal products`
    },
    summerTreats: {
      subTitle: `A treat for hot days! A selection of delicious summer treats best enjoyed chilled.`,
      title: `Delicious summer treats best enjoyed chilled`
    },
    sunBlockRecommendation: {
      subTitle: `Are you fully protected against UV rays? Never suffer from sunburn again! Start your UV care now`,
      title: `2024 special feature on UV care`
    }
  },
  featuredCollections: {
    allShow: `See All Featured Collections`
  },
  footer: {
    genuineDescription: `All our products are genuine.`,
    genuineTitle: `Product Authentication`,
    safeDescription: `We work to protect your privacy and security.`,
    safeTitle: `Privacy and Security `,
    serviceGuide: `Service Guide`,
    userAgreement: `User Agreement`,
    weappDescription1: `Scan QR code and follow`,
    weappDescription2: `Experience Japan with WAmazing`,
    weappTitle: `The WAmazing official account`
  },
  guide: {
    attention1: `Make sure \nAirport is correct.`,
    attention2: `Confirm \nPickup date. `,
    attention3: `Bring passport.`,
    attention4: `You have \nInternet access.`,
    confirmIdentity: (className: string) =>
      `Please follow the instructions displayed on the tablet to confirm <span class=${className}>your identity</span>.`,
    confirmLocation: `Confirm your pick-up location`,
    confirmPassport: `Confirm your passport`,
    confirmQrcode: `Confirm the QR code`,
    description: `How to use the WAmazing Shop\nUse the WAmazing Shop to purchase Japanese souvenirs. Purchased items can be picked up at designated airports during your trip to Japan. We offer a wide variety of popular Japanese cosmetics and confectionery.`,
    dontForget: `Don't forget\n`,
    enterFourDigitNumber: (className: string) =>
      `In front of the locker, enter the <span class=${className}>4-digit number</span> displayed on the tablet in the <span class=${className}>"Enter the 4-digit number"</span> section of the reservation information from the <span class=${className}>reservation details page</span>.`,
    followTabletAndReceive: (className: string) =>
      `Follow the instructions on the locker tablet to <span class=${className}>receive your shopping</span>.`,
    mustBeEPassport: (className: string) => `*The passport must be an <span class=${className}>e-Passport</span>.`,
    note: `*Please bring your passport (must be e-Passport) to verify your identity.`,
    openQrcodeAndScanTablet: (className: string) =>
      `In front of the locker, take out the <span class=${className}>QR code</span> on the <span class=${className}>reservation details page</span>, and scan it on the tablet.`,
    payment: `Payment when you pickup your shopping`,
    receive: `Receiving your shopping\n`,
    title: `Pick-up Information`,
    notes: {
      comeInPerson: `In order to reduce congestion at the time of purchase and pickup, we ask that the person making the reservation come in person to complete the procedure.`,
      note1: `An active internet connection is required to make the payment. Please prepare the environment by yourself.`,
      note2: `The person who made the order must come to the pickup location in person to complete the transaction. `,
      note3: `Please make sure to confirm the location, date and time. `,
      note4: `The person who made the order must bring their passport (must be e-Passport) with a valid landing permit seal affixed to the passport.`,
      note5: `The face of the person who made the order will be photographed. The image taken will be used only for the purpose of confirming the identity of the passport holder, and will be deleted immediately after confirmation.`,
      note6: `Please log in to our service with the account of the person who made the reservation and make the payment.　Please note that you cannot make payments using a different account than the one you have reserved. `,
      note7: `If you do not comply with any of the above, you will not be able to complete the procedure. `,
      other: `Other`,
      readFollowingNotes: `Please read the following before purchasing and picking up items.`,
      title: `Notes`
    },
    page: {
      title: `User's Guide`
    }
  },
  index: {
    BeautyEquipmentsRecommendation: {
      subTitle: `gives you more smooth and resilient skin`,
      title: `Beauty equipments`
    },
    babyProductsRecommendation: {
      subTitle: `We provide a selection of baby essentials such as formula and baby food`,
      title: `Popular Japanese baby products`
    },
    dhcRecommendation: {
      subTitle: `Popular DHC supplements such as vitamins and collagen`,
      title: `DHC Supplements`
    },
    healthFoodRecommendation: {
      subTitle: `Get Japanese health foods not available at the airport`,
      title: `Health Foods`
    },
    maskRecommendation: {
      subTitle: `Make your skin feel good with these popular masks.`,
      title: `Masks`
    },
    matchaRecommendation: {
      subTitle: `Japan is known for its matcha! \nWe provide a selection of popular matcha products`,
      title: `Popular matcha souvenirs`
    },
    omiyageRecommendation: {
      subTitle: `Best word-of-Souvenirs`,
      title: `Popular Souvenirs`
    },
    popularRecommendation: {
      subTitle: `Aselection of the best word-of-mouth items`,
      title: `Must-Buy Items`
    },
    shiseidoBestHit2023: {
      subTitle: `We invite you to try our top-pick cosmetics.`,
      title: `SHISEIDO Best Hit Cosme 2023`
    },
    snacksRecommendation: {
      subTitle: `Impress friends and family with these Japan-only snacks`,
      title: `Popular Sweets & Snacks`
    },
    snacksSetRecommendation: {
      subTitle: `Bring home the perfect souvenir with these “WAmazing" snack sets.`,
      title: `Snack Sets`
    },
    summer2023Recommendation: {
      subtitle: `Recommended Products for \nSummer 2023 Family Vacation `
    }
  },
  issuedCoupon: {
    checkCouponNow: `Access coupon now`,
    couponHasBeenIssued: (className: string) =>
      `You have received your coupon.\nClick <span class=${className}>"Select Coupon" on the cart screen</span> to access your coupons.`
  },
  localSouvenirs: {
    area: {
      suffix: ` Regions`,
      title: (area: string) => `Souvenirs from the ${area}`
    },
    aside: {
      left: {
        title: `Contents`
      }
    },
    buyerComment: {
      title: {
        full: `This month's buyer's pick`,
        row1: `This month's`,
        row2: `Buyer's pick`
      }
    },
    buyerPickUpsByRegion: {
      title: {
        full: `Recommendations from buyers across Japan`,
        row1: `From buyers across Japan`,
        row2: `Recommendations`
      }
    },
    buyerRecommendedMaker: {
      title: {
        full: `This month's featured manufacturer`,
        row1: `This month's`,
        row2: `Featured manufacturer`
      }
    },
    hokkaidoTohoku: {
      description: `The Hokkaido and Tohoku regions are full of local delicacies thanks to their cold climate! Hokkaido is famous for its agricultural and dairy farms, making it famous for souvenirs made using potatoes and dairy. The Tohoku area, which includes Yamagata, Iwate, and Miyagi Prefectures, offers regional soul food and sake (Japanese rice wine) unique to each prefecture.`,
      title: `Hokkaido & Tohoku`
    },
    japan: {
      description1: `Featuring a wide range of local souvenirs from all over Japan! `,
      description2: `With the WAmazing Shop, an online tax-free shop, you can order items in advance and pick them up at airports and train stations, allowing you to purchase souvenirs from all over Japan in one place!\nCheck out souvenirs from regions you are interested in!`,
      navi: `Regional Souvenirs`,
      title: `Regional Souvenirs from Across Japan`
    },
    kansaiChushikoku: {
      description: `The Kansai, Chugoku, and Shikoku regions include Osaka, Kyoto, and Nara, and Hiroshima and Shikoku (Kagawa, Ehime, Tokushima and Kochi) which surround the Seto Inland Sea. The area near the Seto Inland Sea, due to its favorable climate and fabulous seafood, has popular souvenirs made with seafood and lemons!`,
      title: `Kansai, Chugoku, & Shikoku`
    },
    kantoKoshinetsu: {
      description: `The Kanto and Koshinetsu areas feature many tourist hot spots, including Tokyo and Kanagawa, which attract many visitors. There are a variety of souvenirs that are not only tasty but also come in stylish packaging, making for great souvenirs for your family and friends! Niigata, one of the major rice-producing regions in Japan, has many local sake that are popular in Japan.`,
      title: `Kanto & Koshinetsu`
    },
    kyushuOkinawa: {
      description: `The Kyushu & Okinawa region includes Fukuoka, Kumamoto, Kagoshima and Okinawa. Kyushu has many snacks made using mentaiko (cod roe), a local specialty, and shochu, a distilled spirit. Okinawa offers a variety of unique Okinawan souvenirs such as sweets made using locally produced brown sugar and salt and "chinsuko" baked cookies.`,
      title: `Kyushu & Okinawa`
    },
    maker: {
      aokiSofuan: {
        description: `Aoki Shofuan in Osaka is a long-established Japanese confectionery store founded in 1983. Their specialty souvenir "Tsukigesho" is especially popular and is now a classic Osaka souvenir. People from various generations love this store and their products that use carefully selected locally produced ingredients and combine traditional techniques with innovation. The store has a sophisticated design and some of the stores also have café spaces. The specialty "Tsukigesho" can be purchased mainly in the Kansai area. The store is also proactive in contributing to the local community, participating in local events and developing products that use local ingredients.`,
        title: `Aoki Shofuan`
      },
      obusedo: {
        description: `Obusedo is a long-established Japanese confectionery store in Obuse Town, Nagano Prefecture, and is known for its Japanese sweets made with high-quality chestnuts from the region, which is known for its chestnut production. Kuri Kanoko and Kuri Mushi Yokan are particularly popular, and you can enjoy seasonal and limited-time store products while taking in the beautiful townscape. The attached  café and restaurant serve desserts and dishes made using local ingredients. You can feel the history and culture of the store, which was founded about 400 years ago, and you can also experience the heartwarming hospitality.`,
        title: `Obusedo`
      }
    },
    page: {
      description: `This tax-free online store offers more than 500 kinds of local souvenirs from all over Japan, ranging from "very popular classic souvenirs" to "regional limited products usually only available locally." You can pre-order in advance and pick them up at the train station or airport! No need to worry about them being sold out or waiting in line. Enjoy the latest Japanese souvenirs, from "monthly recommendations" to "ranking of popular items," carefully selected by WAmazing's buyers who have traveled all over Japan.`,
      title: `Conquer All 47 Prefectures! Must-Buy Items in Japan, Recommended by WAmazing's Buyers. A Selection of Souvenirs From All Across Japan!`
    },
    prefecture: {
      aichi: `Aichi`,
      akita: `Akita`,
      aomori: `Aomori`,
      chiba: `Chiba`,
      ehime: `Ehime`,
      fukui: `Fukui`,
      fukuoka: `Fukuoka`,
      fukushima: `Fukushima`,
      gifu: `Gifu`,
      gunma: `Gunma`,
      hiroshima: `Hiroshima`,
      hokkaido: `Hokkaido`,
      hyogo: `Hyogo`,
      ibaraki: `Ibaraki`,
      ishikawa: `Ishikawa`,
      iwate: `Iwate`,
      kagawa: `Kagawa`,
      kagoshima: `Kagoshima`,
      kanagawa: `Kanagawa`,
      kochi: `Kochi`,
      kumamoto: `Kumamoto`,
      kyoto: `Kyoto`,
      mie: `Mie`,
      miyagi: `Miyagi`,
      miyazaki: `Miyazaki`,
      nagano: `Nagano`,
      nagasaki: `Nagasaki`,
      nara: `Nara`,
      niigata: `Niigata`,
      oita: `Oita`,
      okayama: `Okayama`,
      okinawa: `Okinawa`,
      osaka: `Osaka`,
      saga: `Saga`,
      saitama: `Saitama`,
      shiga: `Shiga`,
      shimane: `Shimane`,
      shizuoka: `Shizuoka`,
      tochigi: `Tochigi`,
      tokushima: `Tokushima`,
      tokyo: `Tokyo`,
      tottori: `Tottori`,
      toyama: `Toyama`,
      wakayama: `Wakayama`,
      yamagata: `Yamagata`,
      yamaguchi: `Yamaguchi`,
      yamanashi: `Yamanashi`
    },
    region: {
      chugoku: `Chugoku`,
      hokkaido: `Hokkaido`,
      hokuriku: `Hokuriku`,
      kansai: `Kansai`,
      kanto: `Kanto`,
      kyushu: `Kyushu`,
      okinawa: `Okinawa`,
      shikoku: `Shikoku`,
      tohoku: `Tohoku`,
      tokai: `Tokai`,
      airport: {
        chugoku: `Hiroshima Airport`,
        hokkaido: `New Chitose Airport`,
        hokuriku: `null`,
        kansai: `JR Kansai Airport Station`,
        kanto: `JR Narita Airport Station\nJR Narita Airport Terminal 2 Station\nHaneda Airport Terminal 3 Station`,
        kyushu: `Tenjin Bus Terminal\nJR Hakata Station`,
        okinawa: `Naha Airport`,
        shikoku: `null`,
        tohoku: `Sendai Airport`,
        tokai: `Chubu Centrair International Airport`
      },
      description: {
        chugoku: `The Chugoku region offers a wide variety of foods and specialties nurtured by the mild climate. Hiroshima Prefecture's okonomiyaki and Onomichi ramen noodles, and Okayama Prefecture's white peaches and muscats are superb. Izumo soba from Shimane Prefecture and Fugu (pufferfish) sashimi from Yamaguchi Prefecture are also representative of the region's delicacies. In addition, there is a full lineup of confectioneries that make great souvenirs, including momiji manju (steamed buns with red bean paste) from Hiroshima Prefecture and Kibi Dango (sweet millet dumplings) from Okayama Prefecture. The culinary culture born from the fresh seafood and fertile land attracts visitors.`,
        hokkaido: `Hokkaido is popular among tourists from all over the world for its magnificent nature and the exquisite food that is made from the surrounding nature! Agricultural and livestock products, dairy products, seafood, and alcoholic beverages are fresh and of high quality, and the region has long been known in Japan as a "treasure trove for delicious food." In particular, vegetables, fruits, richly flavored dairy products, and fresh seafood are highly praised, and sake and beer are also loved for their local flavor.`,
        hokuriku: `The Hokuriku region is rich in fresh seafood and is especially famous for high-end seafood such as firefly squid from Toyama Prefecture, Echizen crab from Fukui Prefecture, and Nodoguro (blackthroat seaperch) from Ishikawa Prefecture, which has long been a specialty of the Hokuriku area. It is also famous for sake due to its clean water. Sake-brewing has a long history in the Hokuriku region, and sake made with the best sake-brewing methods is characterized by its mild taste and rich aroma. In addition, the Hokuriku region is known for its diverse selection of Japanese sweets, such as Kanazawa's gorgeous traditional Japanaese confectionery made with gold leaf and Fukui's Habutae (Japanese silk from Fukui) mochi.`,
        kansai: `Kansai is a region with a rich "history" and deep culture, and its cuisine is strongly influenced by it. "Matcha" in particular has developed mainly in Kyoto, where many delicious sweets were created along with the tea ceremony culture. From Japanese confectionery made with matcha to Western-style sweets, there is a rich variety to be enjoyed while experiencing the atmosphere of the ancient capital. This fusion is a major attraction of the food offered in the Kansai region.\nIn addition, Fushimi Ward in Kyoto Prefecture and Nada Ward in Hyogo Prefecture have long been known as famous sake-producing areas, where high-quality sake has been brewed using pure water and high-quality rice.`,
        kanto: `In the Kanto region, you can enjoy Edomae (pre-Edo period) cuisine such as Edomae sushi, tempura, and soba. Tokyo also has large fish markets such as Tsukiji Market and Toyosu Market, where fresh fish from all over the country are round up, so you can enjoy fresh seafood. Tokyo, a city of diversity, is home to many latest sweets and souvenirs, but areas such as Ginza and Asakusa also have many long-established Japanese confectionery shops where you can enjoy traditional flavors.`,
        kyushu: `Kyushu is a treasure trove for tasty food, with a wide variety of local specialities to enjoy. Fukuoka Prefecture's Hakata ramen, Oita Prefecture's chicken tempura, and Kagoshima Prefecture's Kurobuta pork are popular. There is also an abundance of fruits and sweets, with Fukuoka Prefecture's Amaou strawberries and Nagasaki Prefecture's Castella being very famous throughout the country. Kyushu is also known for its famous alcohol shochu, which has been popular since long ago and is said to be the alcoholic beverage of choice in Kyushu.`,
        okinawa: `Okinawa has a rich natural environment and a unique culinary culture. Dishes that make use of local ingredients, such as Goya Chanpuru (bitter melon stir-fry), jjimami tofu, and soki soba are exquisite. Souvenirs such as sweets made from the island's chili peppers, Beniimo (purple sweet potato) tarts, and Chinsuko biscuits are very popular! Okinawa is also home to unique alcoholic beverages such as Awamori.`,
        shikoku: `The Shikoku region is characterized by food products that take advantage of its rich nature and mild climate. Each area within the region offers its own unique cuisine, such as Katsuo no Tataki (seared skipjack tuna sashimi) from Kochi Prefecture, fresh sea bream dishes from Ehime Prefecture, Sanuki udon from Kagawa Prefecture, and Awa-o chicken from Tokushima Prefecture. Citrus fruits such as mandarin oranges and Sudachi (small, green citrus fruit) are also abundant, offering fresh and flavorful tastes unique to each area. Shikoku's appeal lies in its food culture, which allows visitors to experience the climate and traditions nurtured in each area.`,
        tohoku: `Located in the northeastern part of Japan, the Tohoku region is rich in delicious seafood, rice, and fermented foods. Visitors can enjoy fresh oysters, scallops, and traditional local cuisine (kiritanpo nabe, wanko soba). The area is also famously known for its sake-brewing, and there is delicious local sake. As an area rich in nature, it is also famous for its cherries and apples.`,
        tokai: `The food of the Tokai region is diverse. Its appeal is summed up in the exquisite cuisine that makes the most of the local specialties of each area, such as Nagoya's exquisite misokatsu, fragrant Hitsumabushi (grilled eel rice bowl), and oden (fish cake strew), which eminated the taste of Shizuoka. Nagoya is known for its unique food culture that stands out from the rest of Japan and has produced a succession of popular products, such as its specialty, Ogura (mixed red bean paste) Toast. If you visit this region, be sure to enjoy its rich and diverse cuisine.`
      },
      label: {
        chugoku: `Chugoku・Shikoku`,
        hokkaido: `Hokkaido・Tohoku`,
        hokuriku: `Tokai・Hokuriku`,
        kansai: `Kansai`,
        kanto: `Kanto`,
        kyushu: `Kyushu・Okinawa`,
        okinawa: `Kyushu・Okinawa`,
        shikoku: `Chugoku・Shikoku`,
        tohoku: `Hokkaido・Tohoku`,
        tokai: `Tokai・Hokuriku`
      }
    },
    relatedArticles: {
      title: {
        full: `Recommended articles related to souvenirs`,
        row1: `Related to souvenirs`,
        row2: `Recommended articles`
      }
    },
    souvenirRanking: {
      title: {
        full: `Japan's souvenir ranking`,
        row1: `Japan's`,
        row2: `souvenir ranking`
      }
    },
    tokaiHokuriku: {
      description: `The Tokai and Hokuriku areas include Aichi, where Nagoya is located, Shizuoka, Ishikawa (Kanazawa), Toyama, and Fukui, where traditional Japanese culture remains strong. Sake from the Hokuriku area is particularly special because of its cold climate and pure water, which make for the ideal conditions for sake production!`,
      title: `Tokai & Hokuriku`
    }
  },
  lp: {
    mediaCoupon: {
      goToTop: `Return to Top`,
      goToWAmazing: `Check the WAmazing Shop`,
      faq: {
        a1: `Unfortunately, you can not change the pick-up day. Please cancel and make the purchase again.`,
        a2: `Pharmaceutical products (distributor: Sugi Pharmacy) are not eligible for tax exemption. If you would like to purchase pharmaceutical products, you must make an additional purchase of JPY 3,000 or more.`,
        a3: `Unfortunately, if you do not have an IC chip in your passport, you will be unable to pick up your purchase.`,
        a4: `Due to legal regulations, tax exemption procedures are not possible, so those who made the purchase must pick it up with their passport.`,
        label: `FAQ`,
        q1: `Can I change the pick-up day?`,
        q2: `Are pharmaceuticals products available as tax-free?`,
        q3: `I do not have a passport with an IC chip. Can I still pick-up my purchase?`,
        q4: `Can I pick-up the purchase even if I am not the one who made the purchase? `,
        q5: `What are the payment options?`,
        a5: {
          aftee: `AFTEE pay now`,
          detail1: `For payment, online credit cards are accepted: VISA, Mastercard, JCB, and American Express cards.`,
          detail2: `Please note that those who use WeChatPay must also use WeChatPay when picking up the purchase  and also to pay the balance.`,
          detail3: `Payments at supermarkets, ATMs, and e-wallets (AFTEE pay now) are also accepted.`
        }
      },
      footer: {
        app: `Download the app from here`,
        enjoy: `Enjoy a wonderful life full of fun in Japan`,
        wamazing: `WAmazing`
      },
      hero: {
        subtext1: `Many popular Japanese souvenirs `,
        subtext2: `Online Reservation`,
        subtext3: `Pick-up souvenirs at the airport`,
        subtitle: `No need to wait in line!`,
        text1: `TODO: lp.mediaCoupon.hero.text1@en`,
        text2: `TODO: lp.mediaCoupon.hero.text2@en`,
        text3: `TODO: lp.mediaCoupon.hero.text3@en`,
        title: `Enjoy online tax-free shopping, traveling,\nand more`
      },
      how: {
        goToTop: `Try shopping using a coupon`,
        label: `How to use the special discount coupon`,
        labelWithPrice: (price: string) => `How to use the ${price}-yen coupon`,
        labelWithRate: (rate: number) => `How to use the ${formatDigits(100 * rate)}% coupon`,
        list1: `Obtain the coupon on the distribution page`,
        list1Click: `Click below to claim your coupon`,
        list2: `Add to cart`,
        list3: `Check your cart`,
        list4: `Tap "Select Coupon" under "Amount Detail" on the cart screen.`,
        list5: `Enter the code copied in 1 and tap "OK"`,
        list6: `The coupon will be displayed, so check it and tap "Select"`,
        list7: `Your coupon has been applied!`,
        notice1: `*To be <strong>qualified</strong> for <strong>tax exemption</strong>, you must spend <strong>JPY 5,000 or more</strong>, so please enjoy your shopping by checking out the <strong>seller</strong> on the product page. Whether a coupon can be used is determined by the coupon's terms and conditions.`
      },
      introduction: {
        feature1: `Order before traveling`,
        feature2: `Pick-up at the airport`,
        feature3: `Tax exemption on your own`,
        forWamazing: `WAmazing Shop is\na service where\nyou can <em>order items online </em>\nand <em>pick-up at airports in  Japan</em>`,
        introText: `Proposal on new online tax-free shopping `
      },
      notice: {
        label: `Important Notice`,
        notice1: {
          text1: `Some products may be out of stock due to their popularity.`,
          text2: `Please note that if an item is out of stock, `,
          text3: `it may take some time for the manufacturer to restock it.`
        },
        notice2: {
          text1: `We recommend customers `,
          text2: `to make their purchase as soon as possible`
        }
      },
      problem: {
        list1: `<em>Trouble carrying luggage</em> during travel`,
        list2: `<em>Difficulty</em> of taking care of a child with all the luggage`,
        list3: `<em>Nearly bumping</em> into people on the train and the road`,
        list4: `<em>No empty</em> coin-operated lockers`,
        list5: `<em>Difficulty of finding shops</em> that have items you are looking for`,
        list6: `<em>No time</em> at the airport on the way back to shop for souvenirs`,
        list7: `<em>Can't enjoy shopping</em> when your time is limited`,
        list8: `<em>Souvenirs were more expensive</em> than you imagined`,
        more: `Do you want to enjoy more time sightseeing, \n`,
        note1: `We can help to solve your problems for a \n`,
        note2: `memorable trip to Japan`,
        strong: `but are worried about the following?`,
        point: {
          subject: `WAmazing Shop`,
          subtext1: `Shorten your souvenir searching time`,
          subtext2: `Travel easily without carrying heavy luggage`,
          subtext3: `Shop at great value for money with tax-free prices`,
          text1: `TODO: lp.mediaCoupon.problem.point.text1@en`,
          text2: `TODO: lp.mediaCoupon.problem.point.text2@en`,
          text3: `TODO: lp.mediaCoupon.problem.point.text3@en`
        }
      },
      safety: {
        label: `Three Major Comforts for Shopping at Wamazing`,
        subtitle: `All of our products are genuine products.`,
        title: `Product authenticity`,
        list1: {
          text: `We sell our pharmaceutical products under the guidance of Sugi Pharmacy.`,
          title: `Pharmaceutical products`
        },
        list2: {
          text: `We are committed to protecting your privacy and security.`,
          title: `Handling of personal information`
        }
      },
      showProducts: {
        add: `More popular items to be added to the list!`,
        find1: `Because it's online`,
        find2: `it's easy to find the products you want`,
        label: `Save time and effort searching for products`,
        title1: `<em>Over 10,000</em> products! `,
        title2: `Order products from all over Japan!`
      },
      unique: {
        label: `Difference from shopping at the airport`,
        list1: {
          text: `No need to wait in line for a long time at the busy tax-free counter.`,
          title: `No need to wait in line at the tax-free counter`,
          type: `No need \nto wait in line`
        },
        list2: {
          text: `In some cases, products are sold with <em>tax-free fees</em> added.`,
          title: `Handling fee is not included`,
          type: `Handling\n fee`
        },
        list3: {
          text: `We handle many Japan-specific products.`,
          title: `Large selection of items`,
          type: `Japan \nspecific`
        },
        list4: {
          text: `We deal in many genres such as cosmetics, snacks, medicines, and anime goods.`,
          title: `Large selection of items`,
          type: `Even \nanime goods\n too`
        }
      },
      userGuide: {
        label: `Don't miss out picture-worthy moments`,
        subtitle: `luggage-free trip`,
        title: `No need to carry souvenirs on your `,
        guide: {
          icon1: `Bus Terminal`,
          map1: `Pick-up available at <em>11 locations nationwide!</em>\nLockers are installed at airports and stations in major cities`,
          multi: `Available in multiple languages`,
          step1: `Orders can be placed from <em>3 months prior</em> to travel up to <em>3 days prior</em> to pick-up!\n\nWhen ordering, specify the location you will use to receive your items`,
          step2: `Receive souvenirs uisng your <em>passport</em>`,
          step3: `Enjoy sightseeing,\nreceive your souvenirs\nand return home conveniently.`,
          support: `If you have any problems with the locker,\nplease contact customer support via <em>QR code</em>`,
          text: `WAmazing Shop User Guide`,
          threeMins: `Pick-up time: about 3 minutes`,
          title: `3 easy steps from ordering to pick-up`
        }
      },
      voice: {
        label: `Customer reviews`,
        list1: `This e-commerce site allows you to buy sweets in quantity from many brands and stores, making it simple to navigate the tax exemption restrictions. There is also a wide variety of products.`,
        list2: `I went ahead and purchased the items at WAmazing Shop because I did not have much time to shop when I arrived in Japan. I found it very convenient.`,
        list3: `When I saw the comment "You don't have to carry a lot of stuff." I thought how convenient, so I decided to shop here.`,
        list4: `We greatly appreciate the responsiveness of customer service and their willingness to solve problems. I will use WAmazing's related services again in the future when the opportunity arises.`
      }
    },
    serviceIntroduction: {
      returnToSnow: `Return to WAmazing Snow`,
      snowHero: {
        title: `An online tax-free shop \n to make your ski trip \n even more enjoyable`
      },
      snowProblem: {
        list1: `<em>Trouble carrying ski gear</em>`,
        list2: `<em>Difficulty finding stores</em> that carry the souvenirs you want`,
        list3: `<em>Long lines</em> at tax-free counters or registers`,
        more: `Are you struggling with these issues`,
        note: `memorable ski trip`,
        strong: `when trying to enjoy skiing or snowboarding?`
      }
    }
  },
  lunarNewYearSale: {
    drugDiscount: (className: string) => `TODO: lunarNewYearSale.drugDiscount@en`,
    metaDescription: `[10% Tax-Free Discount + Up to 75% OFF] Exclusive Deals for the Lunar New Year Campaign!`,
    metaTitle: `WAmazing's Lunar New Year Campaign`
  },
  maker: {
    maker: `Manufacturer`
  },
  mypage: {
    title: `My Page`
  },
  nativeApp: {
    badge: {
      exclusive: `Exclusive coupons for app users`,
      title: (pink: string) =>
        `<span class=${pink}>Exclusive coupons for app users</span>\nApp rating: 4.7 / More than 3,500 reviews`,
      download: {
        count: {
          currentDate: `As of September 5, 2024`,
          text: `Total downloads have exceeded 300,000`
        }
      },
      rating: {
        title: `App rating:4.7/3,557 reviews`
      }
    }
  },
  orderForm: {
    addNewCard: `Add a new card`,
    andConfirmedInput: `.`,
    checkNotes: `Please check the notes`,
    creditCard: `Credit Card`,
    creditCardInformation: `Payment method`,
    dateOfBirth: `Date Of Birth`,
    dateOfLanding: `Date Of Arrival`,
    fillDateOfBirthAsPassport: `Please make sure to enter your date of birth as they appear on your passport.`,
    firstName: `FIRST NAME (as per passport)`,
    iAgree: `I  confirmed`,
    lastName: `LAST NAME (as per passport)`,
    nameAndDateOfBirth: `Name and Date of Birth`,
    notPurchaseWithoutDateOfBirthAsPassport: `Please note that you will not be able to purchase tax-free items if your date of birth do not appear on your passport.`,
    orderPlaced: `Order Placed`,
    passport: `Passport`,
    passportInformation: `Passport information`,
    personalInformation: `Customer information`,
    pickupContent1: `・Please select a time during your stay in Japan`,
    pickupDate: `Pickup Date`,
    pickupIdentity: `Personal Information`,
    pickupIdentitySub: `Customer information will be used for WAmazing Shop`,
    pickupSchedule: `Pickup Schedule`,
    pickupTime: `Pickup time (Select date first)`,
    statusOfResidence: `Status of Residence`,
    supportedCreditCards: `We accept the following credit cards`,
    taxFreeProcedures: `Tax-free procedures`,
    userAgreement: `User Agreement`,
    validatorMessage: {
      invalidCreditCardType: `Please use VISA, Mastercard, JCB, or American Express`,
      mustBeAlphaNum: (field: string) => `Please enter ${field} using alphabetical/numerical characters.`,
      mustBeAlphaNumSymbols: (field: string) =>
        `Please enter ${field} using alphabetical/numerical characters, hyphens, or underscores.`,
      mustBeAlphabets: (field: string) => `Please enter ${field} using alphabetic characters.`,
      mustBeNum: (field: string) => `Please using half-width numbers ${field}`,
      mustBeOver20: `The sale of alcohol to persons under 20 years of age is prohibited under Japanese law.`,
      mustNotBeEmpty: (field: string) => `Please enter ${field}`,
      mustSelectCorrectValue: `Please enter the correct nationality code`
    }
  },
  orders: {
    actuallyPickedAt: `Actual Pickup Time`,
    areYouSureToCancelOrder: `Are you sure you want to cancel?`,
    autoCancelled: `Automatic cancellation`,
    autoCancelledAndCollected: (date: string, className: string) =>
      `Since the retrieval deadline <span class=${className}>${date}</span> has passed, your order has been cancelled and the package has been collected.`,
    awaitingNextUse: `We look forward to serving you again.`,
    canBePickedUpUponArrival: `*can be picked up upon arrival in Japan`,
    cancelOrder: `Canceling your order`,
    cancellationFee: `Cancelled`,
    cancellationFeeWillBeChargedAfter: (date: string) =>
      `If you cancel after ${date} (Japan Standard Time), the fee you paid will apply as the cancellation fee.`,
    cancelled: `Cancelled Items`,
    cancelledAt: `Cancel Order`,
    cancelledByCustomer: `Your reservation has been cancelled \nas requested`,
    checkReceiveMethod: `Confirm pickup method`,
    checkReceivePlace: `Confirm pickup location`,
    checkVjwReg: `Check VJW registration method`,
    confirmPickupMethod: `Pick-up location and method`,
    createOrder: `Create Order`,
    deadline: `Retrieval Deadline`,
    depositAmount: (field: number) => `The reservation free will be JPY${field}. `,
    earliestCollectionDate: `Earliest collection date`,
    earliestNotice: `*Depending on the product, order processing and shipping times vary.`,
    firstPaid: `Reservation completed.`,
    goOrderDetailOfSmartPhone: `\nGo to the order detail screen of your  phone, to confirm the QR code  for receiving the product ,and to enter the code for settling the remaining balance.\n`,
    infoForPickUp: `Necessary information for receiving items`,
    noCancellationFeeCharged: `No cancellation fee will be charged.`,
    note1: `*1 Tax exemption will not be completed until you receive your order, therefore the booking fee will be 20% of the price including tax.`,
    note2: `*2 The reservation fee will be added to the purchase price at final payment.`,
    note3: `*3 For taxable products you will pay the price directly, not a reservation fee.`,
    openLocker1: `Open the locker number`,
    openLocker2: (className: string) => ` and <span class=${className}>remove the item(s).</span>`,
    order: `Order`,
    orderCancelled: `Order cancelled.`,
    orderId: `Order ID`,
    orderPlaced: `Order Placed`,
    orderPlacedAt: `Order Placement Time`,
    orderTitle: `Order Details`,
    payAtCounter: (amount: number, className: string) =>
      `The remaining amount  will be <span class=${className}>JPY${commaedInteger(amount)}</span>.`,
    payRemainingAmount: `Pay the remaining amount when you pick up your items.`,
    paymentProcedure: `Enter 4-digit number`,
    pickupCompleted: `Pickup is complete.`,
    pickupLocation: `Pickup location`,
    pleasePickUpBeforeDeadline: (date: string) =>
      `Please retrieve your package by${date} Japan time.\nIf you miss the deadline, your order will be cancelled and the package will be collected.`,
    qrcodeForPickUp: `QR code for receiving items`,
    requireInternetEnv: `*An active internet connection is required when you pick up your order\n`,
    retrievalProblems: `"Retrieval problems" here`,
    scanQrOnDevice: `Please show this QR code at the pickup location`,
    secondPaid: `Payment completed.`,
    showQrcode: `Scan this QR code with the locker camera.`,
    startReceive: `Start pickup`,
    thankYouForShopping: `Thank you for shopping with WAmazing.`,
    thankYouMessage: `Thank you for using our service.`,
    vjwRegistered: `Yes, I have registered for VJW`,
    cancelPolicy: {
      Charge20: `20% of Purchase Amount`,
      freeCancellation: `Free cancellation`,
      note1: `Before shipping: No cancellation fee will be charged.`,
      note2: `After shipping: 100% of the reservation fee (equivalent to 20% of the product price, including tax)`,
      note3: `No cancellation, Item not delivered: 100% of the reservation fee (equivalent to 20% of the product price, including tax)`,
      note4: `In the event of the above cancellation by the customer, the reservation fee paid at the time of reservation will also apply.`,
      note5: `Please note that coupons cannot be returned if  they have been used or if  cancellation fee has already been incurred.`,
      note6: `If taxable items are included, we will refund 80% of the total amount paid for taxable items.`,
      title: `Cancellation Policy`
    },
    haneda_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `The <a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>pick-up point at Haneda Airport Terminal 3</a> is located inside JMonorail Ticket Gate.`,
      noteForUsersWithoutJr: (className?: string) =>
        `※Please <span class=${className}>purchase a separate ticket</span> to enter the station for those who are not using the Monorail.`
    },
    kansai_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `The <a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>pick-up point at Kansai Airport</a> is located inside JR Kansai Airport Station.`,
      noteForUsersWithoutJr: (className?: string) =>
        `※Please <span class=${className}>purchase a separate ticket</span> to enter the station for those who are not using the JR line.`
    },
    locker: {
      enter4number: `Enter the 4-digit number displayed on the locker tablet.`,
      next: `Next`,
      payAll: (amount: number, className: string) =>
        `Total amount is <span class=${className}>JPY${commaedInteger(amount)}</span>.`,
      payRemainingAmount: `Pay the remaining amount`,
      paymentDetail: `Payment Details`
    },
    narita1_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `The <a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>pick-up point at  Narita Airport Terminal 1</a>  is located inside JR Narita Airport StationTicket Gate.　Please <span class=${boldClassName}>purchase a separate ticket</span> to enter the station for those who are not using the JR East trains.\n`
    },
    narita2_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `The <a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>pick-up point at  JR Narita Airport Terminal 2</a> is located inside JR Airport Terminal 2 StationTicket Gate.　Please <span class=${boldClassName}>purchase a separate ticket</span> to enter the station for those who are not using the JR East trains.\n`
    },
    pickupItems: {
      note1: `Only the person who made the order can purchase and pick up the items.`,
      note2: `The passport (must be e-Passport) of the person who made the order is required.`,
      note3: `An active internet connection is required when you pick up your order.`,
      title: `Picking up items`
    }
  },
  orderstep: {
    step1: `Shop online`,
    step2: `Pay\nReservation fee`,
    step3: `Pay and\nPickup items`,
    title: `Flow`
  },
  payment: {
    cardValidUntil: `Expiration Date`,
    creditCardHolder: `Card Holder`,
    creditCardNumber: `Credit Card Number`,
    errorRegisteringCreditCard: `Error registering credit card.`
  },
  pickupSupport: {
    cancel: `I want a cancelation`,
    cancellationFeeMayBeAdded: `Cancellation fee may be added.`,
    chooseOverseasShippingOrCancellation: `Choose overseas shipping or cancellation`,
    consumptionTaxMayBeAdded: `Consumption tax may be added for overseas shipping.`,
    contactUs: `Contact us`,
    deliver: `I want it delivered`,
    deliverOrCancel: `Deliver or cancel your item(s)`,
    deliverOverseasOrCancel: `You can deliver overseas or cancel`,
    flow: `Flow`,
    note: `*Possible even after leaving Japan.`,
    overseasShippingCostsMayBeAdded: `Overseas shipping costs may be added.`,
    pressTheButton: `Press the Contact Us button to start the process.`,
    scanQrCode: `Scan QR code`,
    sendARequest: `Send a request through the contact form.`,
    sendTheProblem: `Send the problem to the Contact Us chat.`,
    title: `Would you like help?`,
    waitForCustomerSupport: `Wait for customer support to contact you.`
  },
  popularBrand: {
    title: `Popular Brands`
  },
  product: {
    shopping: `Shopping`
  },
  products: {
    FromPickUpDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `from ${hour}:${minute} on ${month} ${day}, ${year} `,
    alsoSearched: `If you are under 20 years of age, we will be unable to complete the sale.`,
    amountPaidAtReservation: `Amount paid at reservation`,
    amountPaidUponPickup: `Amount paid upon pick-up`,
    bestBefore: `Best/Use before`,
    bestBeforeDate: `best-before date`,
    bookingFee: `Reservation fee`,
    bookingFeeOfVendor: (vendor: string) => `${vendor} reservation fee *1,2`,
    brand: `Brand`,
    buyerComment: `Buyer's comments`,
    customersAlsoSearched: `Similar products`,
    desc: `Product Description`,
    details: `Details`,
    fastestDeliveryDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `Fastest delivery time:  ${month} ${day}, ${year} ${hour}:${minute}`,
    finalPayment: `Final payment`,
    findOutMoreAboutWamazing: `More about the WAmazing Shop service`,
    grossWeightGram: `Weight`,
    ingredients: `Ingredients`,
    loginToAddToCart: `Please log-in\nto add to cart`,
    maxOrderCountAlert: `購入可能な数に達成しているため、これ以上の注文はできません。ご了承お願いします`,
    minimumBuyPerOrder: (minimum: number) => `Minimum of ${minimum} items `,
    name: `Product Name`,
    netContent: `Contents`,
    note1: `*Depending on the product, order processing and shipping times vary, and it may be possible to move the receipt date forward.`,
    orderLimitPerOrder: (limit: number) => `Maximum of ${limit} items `,
    outOfStock: `Temporarily Out of Stock`,
    pay: `Buy Now`,
    payBookingFee: `Buy Now`,
    point1: (className: string) => `Order <span class=${className}>Before Your Trip</span>`,
    point2: (className: string) => `Pick-up <span class=${className}>at the Airport</span>`,
    point3: (className: string) => `Self-Service <span class=${className}>Tax-Free Shopping</span>`,
    price: `Price`,
    priceOfTaxFreeMerchandise: `Price of tax-free merchandise`,
    productDescription: (product: string) =>
      `If you are looking to purchase ${product} Japanese souvenirs, please visit WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`,
    productInfo: `Product Info`,
    productPriceOfVendor: (vendor: string) => `${vendor}'s product price *3`,
    reason: `Perk`,
    sellingPriceTaxFree: `Tax-Free Price`,
    sellingPriceTaxIncluded: `Tax Included Price`,
    shippingDeadline: (year: string, month: string, day: string) =>
      `Due to Limited-time items, the due date for receipt is ${month} ${day}, ${year}`,
    shiseido: `Shiseido Authorized Online Shop`,
    showMoreServiceInformation: `See more details on our services`,
    size: `Size`,
    stockNotification: `Back in Stock Notification`,
    stockNotificationDesc: `Once the item is back in stock, you will receive an email to your registered email address. Do you confirm you wish to sign up?`,
    stockNotificationNotLogin: `You must log in first to sign up for back in stock notifications.`,
    stockNotificationRegistered: `You are now registered for a back in stock notification!`,
    stockNotificationTitle: `Do you want to sign up for a back in stock notification?`,
    taxFreePrice: `Tax-Free Price`,
    undiscountedPrice: `Undiscounted Price`,
    waitingReStock: `Waiting for restock`,
    whyBuyFromWAmazing: `Why buy from WAmazing Shop`,
    alcohol: {
      ageVerification: `・Is the person making the purchase over 20 years of age?`,
      airportsWithAlcoholPickupRestrictions: `Sake cannot be picked up at Naha or New Chitose airports.`,
      alcoholContent: `Alcohol Content`,
      confirm: `Please check \nthe tax-free conditions`,
      howToConfirm: `■How to Confirm`,
      ingredients: `Ingredients`,
      japaneseLowDesc: `・Japanese law prohibits the sale and consumption of alcoholic beverages to persons under 20 years of age.`,
      pageDesc: `*Since the vendor(Tokyu Department Store) for alcoholic products is different than for other items, the total for both type of items has to add up to over JPY 5,000 respectively to qualify for tax-free shopping.`,
      passportAgeVerification: `*We may ask you to present your passport for age verification.`,
      polishingRatio: `Polishing ratio`,
      productionArea: `Place of production`,
      regardingSales: `■Regarding the sale of alcoholic beverages`,
      regardingSalesDesc: (className: string) =>
        `・Alcoholic beverages are sold by a different vendor than other items, so you cannot add other types of items to the total amount.\n<span class=${className}>・The total for both alcoholic beverages and other types of items must exceed JPY 5,000 respectively. Please check the total amount for each type of items.</span>\n・Please refer to the image below for how to identify alcoholic beverages (Tokyu Department Store).`,
      reminderForAlcoholImportTaxExemptionLimit: `When entering a country/region with alcohol, there is a limit to the amount of duty-free alcohol you are allowed to bring. Please confirm the amount yourself.`,
      storageMethod: `How to store`,
      taxFreeAlcoholPurchaseThreshold: `According to Japanese law, the purchase total from each seller needs to be minimum JPY 5,000 to meet tax-free conditions.`,
      title: `ALC.`,
      yesAge20: `Yes, I am above the age of 20.`,
      flavor: {
        dry: `Dry`,
        sweet: `Sweet`
      }
    },
    buyerCommentLabel: {
      title: `Buyer's Pick`,
      patch: {
        text: `See Notes`
      }
    },
    chemicals: {
      confirm: `Please check the notes`
    },
    homeAppliance: {
      checkAgreement: `Confirm the terms and conditions for home appliances`,
      afterSupport: {
        title: `Product support after purchase`
      },
      brandSpecificRemarks: {
        title: `Additional information on other brands and products`
      },
      contactInfo: {
        desc: `If there is any problem with the product, please contact us using the following inquiry form, selecting "Tax-free EC" in the subject line.`,
        details: `We do not process returns or refunds based on customer convenience. \nHowever, if a product experiences a natural malfunction during regular use, we will honor the warranty as specified by each company's policy.\nFor products eligible for international support, if within the warranty period, we can guide you to the manufacturer's customer support center near your residence. \nPlease refer to the warranty certificate for details of each manufacturer's warranty policy.`,
        title: `Contact information`
      },
      returnRefundPolicy: {
        desc: `If you receive a defective product, we typically initiate a refund upon receiving the returned item.\nPlease contact the above contact information within ten days of receiving the product. Please note that issues cannot be classified as initial defects if more than 11 days have passed since you received the product.`,
        mainTexts: `The support center will verify initial defects. We may request videos or images from you as part of this procedure.*If you cannot provide videos or images, we may not be able to process refunds or returns.\nCustomers are responsible for the return shipping fee.`,
        title: `Returns and refunds due to initial defects`
      },
      returnRefundPolicyExtra: {
        desc: `If we are unable to verify any issues or defects with the product at our company, we may be unable to process a refund. `,
        mainTexts: `We do not process returns or refunds based on customer convenience after the product has been received.\nAltered or modified products by the customer are ineligible for returns or refunds.`,
        title: `Additional Information on returns and refunds`
      },
      sendBackRepair: {
        desc: `After receiving the product, if a defect is discovered on the 11th day or later and you contact us, we will handle it as a "repair."\nWe offer free repair services through our "send-back repair" program (*Note) if the item is within the warranty period.`,
        mainTexts: `Please note that repair charges may apply depending on the nature of the issue.\nPlease send the original product to our specified location, where we will conduct repairs in accordance with the manufacturer's warranty before resending it to you.\nCustomers are responsible for the return shipping and reshipping costs after repair.\n*Note: This service involves sending the defective product to our company, where we will perform repairs or other necessary actions before returning the product to you.`,
        title: `Send-back repair program for defective products`
      },
      sendBackRepairExtra: {
        remark: `If no issues or defects are found by our company, we cannot proceed with any further actions.`,
        title: `Additional Information on repair services`,
        condition: {
          desc: `If you send back the product for repair and neither our company nor the manufacturer can confirm any malfunctions or defects, we cannot proceed with the repair. We will simply repackage the product and send it back to you. (The return shipping fee will generally be borne by the customer.)\nPlease note that even if it's within the warranty period, there will be a charge for repairs in the following cases:`,
          details: `Loss of purchase receipts, invoices, or warranty documents required for verification.\nMalfunction or damage caused by improper handling (installation).\nMalfunction or damage caused by water exposure, dropping, pressure (such as being stepped on), etc.\nMalfunction or damage caused by modifications or unauthorized repair.\nMalfunction or damage caused by fires, earthquakes, floods, lightning, or other natural disasters.\nMalfunction or damage that occurred during transportation.\nMalfunction or damage caused by power outages, lightning, or abnormally high voltage.\nMalfunction or damage caused by other installed equipment or devices.`
        }
      },
      sony: {
        desc: `We accept international warranty claims (repair services) in 47 countries worldwide. Once you contact us, we will inform you about the subsequent procedures. Please check the eligible countries from the following link: `,
        title: `SONY`
      },
      watch: {
        brandList: (
          seikoUrl: string,
          citizenUrl: string,
          seikoEpsonUrl: string,
          anchorTagClassName: string,
          listTagClassName: string
        ) =>
          `<li class=${listTagClassName}>Seiko Watch Corporation: <a href=${seikoUrl} class=${anchorTagClassName} target='_blank'>${seikoUrl}</a>（Warranty period: 1 year）</li>\n<li class=${listTagClassName}>Citizen Watch Co., Ltd: <a href=${citizenUrl} class=${anchorTagClassName} target='_blank'>${citizenUrl}</a>（Warranty period: 1 year）</li>\n<li class=${listTagClassName}>Seiko Epson Corporation (Orient): <a href=${seikoEpsonUrl} class=${anchorTagClassName} target='_blank'>${seikoEpsonUrl}</a>（Warranty period: 1 year）</li>`,
        desc: `We will provide support according to the manufacturer's warranty. Please check the warranty details for each company from the following links:`,
        title: `Watches`,
        precaution: {
          mainTexts: `The warranty does not apply to watches with bands that have been adjusted by the customer.\n[Automatic/Kinetic] watches generate power and store it using vibrations. If the watch has not been used for a long time or is only used for a few hours a day, it may stop or experience slight time (second hand) discrepancies. Please shake the watch for a few minutes to generate power and confirm its functionality. (Vibration: Shake the watch for a few minutes to generate power)\nFor quartz watches, the battery installed in the purchased watch serves as a monitor battery used to check functions and performance. Therefore, there may be no remaining battery life after purchase.\nPlease note that returns for [limited edition watches], [mechanical/manual winding watches], and [high-value items] due to customer preference are not accepted after delivery.`,
          title: `Accompanying notes`
        }
      }
    },
    medicine: {
      Ingredients: `Ingredients/content`,
      Inquiries: `Inquiries`,
      InquiriesForClick: `For inquiries please click here`,
      administration: `Administration/Dosage`,
      consult: `When to consult a doctor`,
      contraindications: `Contraindications`,
      couponText: (rate: number) => `${rate}% OFF the listed price`,
      discountText: `Pharmaceuticals coupon`,
      distributorContact: `For Product Inquiries`,
      effects: `Efficacy/Effects`,
      notice: `*Before purchasing, please read the "Precautions" carefully.\n*Since tax-free sales of pharmaceuticals (sold by Sugi Pharmacy Kawaguchi Tozuka Store) online are prohibited by law, all pharmaceuticals are sold at tax-inclusive prices. WAmazing is currently running a campaign where the tax amount for all pharmaceuticals is automatically discounted at checkout.\n*If you purchase only pharmaceutical products (Seller :\nSugi Pharmacy Kawaguchi Tozuka Store) , you must purchase a minimum of JPY 1,000.`,
      other: `Other Precautions`,
      precautions: `Precautions for storage and use`,
      shelfLife: `Shelf Life`,
      Information: {
        desc: (category: string, className: string) =>
          `- This product is classified as a "${category}". When making a purchase, please read carefully and follow the <span class=${className}>"Contraindications," "When to consult a doctor," "Administration/Dosage," and "Precautions for Use" listed on the website before proceeding with your order.</span>\n- If you have any questions about pharmaceutical products, please consult your physician, pharmacist, or registered sales representative before buying.\n*The medicines available for sale have a minimum expiration date of at least 6 months.`,
        title: `Information on the sale of pharmaceutical products`
      },
      abused: {
        desc: `In order to prevent potential risks to customers due to potential misuse, by law, you are required to confirm the following statements to purchase pharmaceutical products containing the designated ingredients listed below. In addition, in accordance with Japanese law, the sales quantity is limited to one per person.\n`,
        title: `Contains potentially addictive substances that may be abused or otherwise misused. Please read the precautions carefully before purchasing.`,
        confirm: {
          least18years: `① I am at least 18 years of age.`,
          notBoughtAnyMedicine: `② I have not bought any medicine with the same effects as the one I purchased this time from other pharmacies.`,
          notMadeConsecutive: `③ I have not made consecutive purchases or regularly taken this medication, or any other medications with the same effects.`,
          title: `■Cautions before purchase and use`
        },
        ingredient: {
          desc: `- Ephedrine - Codeine - Dihydrocodeine - Bromovalerylurea - Methylephedrine - Pseudoephedrine`,
          title: `■ I have confirmed that there are ingredients that may be potentially abused.\n(This applies to drugs containing the following ingredients)`
        }
      }
    },
    notice: {
      expectedRestockDate: (year: number, month: number, day: number) =>
        `This item is expected to be restocked on <em>${month}/${day}/${year}</em>`,
      restockDateUndetermined: `The restocking date for this item is <em>undetermined</em>`,
      restockDateUndeterminedShort: `Restocking date undetermined`,
      restockNotificationEmail: `Restock notifications will be sent to your registered email.`,
      restockNotificationEmailNote: `*The restock date may be earlier/later.`,
      restockNotificationSet: `Restock notification set`,
      restockNotificationSetup: `Restock notification has been set up`,
      scheduledArrival: (month: number, day: number) => `Scheduled to arrive on ${month}/${day}`,
      wishRestockNotification: `I wish to receive a restock notification`
    },
    originalPoint: {
      title: (product: string) => `TODO: products.originalPoint.title@en`
    },
    promo: {
      labelText: `Limited-Time 10% OFF`
    },
    sort: {
      popular: `By Popularity`,
      priceAsc: `Price (Low to High)`,
      priceDesc: `Price (High to Low)`
    },
    tokyuStore: {
      liquorLp: {
        brewery: `Brewery`,
        description: `The WAmazing Shop has collaborated with Tokyu Department Store to deliver high-quality sake made by traditional yet innovative sake breweries from all over Japan.`,
        intro: `Throughout Japan, there are many hidden local sakes only known by experts and rare local sakes that are hard to find in stores. The WAmazing Shop has collaborated with Tokyu Department Store to deliver high-quality sake made by traditional yet innovative sake breweries from all over Japan.`,
        otherRecommendedSake: `Other\nRecommended\nSake`,
        recommendedWayToDrink: `Recommended way of drinking`,
        title: `High-quality sake made by traditional`,
        typeOfSake: `Types of sake`,
        dassai: {
          alcoholContent: `15`,
          brandName: `DASSAI`,
          brewery: `Asahi Shuzo Co., Ltd.`,
          breweryDesc: `Throughout our journey, our goal has been to craft sake that is both delicious and enjoyable, prioritizing these qualities over large-scale sales or producing a beverage solely for intoxication. Above all, we aspire to remain a sake brewery that promotes a joyful life enriched by sake.`,
          breweryDescTitle: `We craft sake designed for enjoyment, not for the purpose of intoxication or profit`,
          breweryUrl: `https://www.asahishuzo.ne.jp/en/`,
          breweryUrlTitle: `Source: AsahiShuzo Co., Ltd. official website`,
          characteristic: `To craft the ultimate Junmai-Daiginjo sake, we polished Yamada-Nishiki rice down to 23%. `,
          ingredients: `100% Yamada-Nishiki Rice, Malted Rice`,
          netContent: `720mL`,
          polishingRatio: `23`,
          price: `5700`,
          productDesc: `Dassai's flagship sake with an elegant aroma, a beautiful honey-like sweetness, and a crisp, lingering finish. `,
          productName: `DASSAI 23 with Wooden Box 720mL`,
          productionArea: `Yamaguchi Prefecture`,
          recommendedWayToDrink: `Cold / Room Temperature`,
          storageMethod: `Cool, dark place without temperature fluctuations\nRefrigeration is recommended for long-term storage`,
          typeOfSake: `Junmai Daiginjo`
        },
        hakkaisan: {
          alcoholContent: `17`,
          brandName: `HAKKAISAN`,
          brewery: `HAKKAISAN BREWERY`,
          breweryDesc: `Founded in 1923 in the Uonuma region of Niigata Prefecture, areas with one of the heaviest snowfalls in Japan.\nUsing the extremely soft water "Raiden-sama no Shimizu," derived from the sacred mountain Mt. Hakkaisan, we continue to create "a refreshing sake that you won't get tired of drinking and that complements your meal and communication.''`,
          breweryDescTitle: `Making sake that doesn't interfere with the food and that you never get tired of drinking`,
          breweryUrl: `https://ec-hakkaisan.com/pages/about`,
          breweryUrlTitle: `Reference: Hakkaisan official website`,
          characteristic: `The taste is light yet full of flavor.\nThis is a Junmai Daiginjo brewed at the brewery Kowagura.`,
          ingredients: `Rice (Yamada Nishiki from Hyogo Prefecture) / Rice malt`,
          netContent: `720mL`,
          polishingRatio: `45`,
          price: `6,000`,
          productDesc: `We have poured the craftsmanship and passion of our brewers into our products without making any compromises when it comes to quality. The taste is light yet full of flavor. As a "Japanese sake" that helps enhance the flavor of your food, we continue to strive to create a sake that not only excels in Japan but also with food around the world.`,
          productName: `HAKKAISAN Junmai Daiginjo Kowagura 720mL`,
          productionArea: `Niigata Prefecture`,
          recommendedWayToDrink: `Cold Sake / Room Temperature`,
          storageMethod: `A cool, dark place that doesn't experience a difference in temperature\nRefrigeration recommended for long-term storage`,
          typeOfSake: `Junmai Daiginjo`
        },
        imayoTsukasa: {
          alcoholContent: `17`,
          brandName: `Imayo Tsukasa`,
          brewery: `Imayo Tsukasa`,
          breweryDesc: `Imayo Tsukasa Sake Brewery was founded in 1767 by the first-generation brewer Tajimaya Juzaemon. Initially, the business was in the liquor wholesale business, ryokan (traditional Japanese inn) business, and restaurant business.\nFrom the late Edo period to the early Meiji period, Niigata is said to have had a larger population than Edo, as Kitamaebune cargo ships frequently stopped at the port. As a result, the city of Niigata is full of vitality, and Imayo Tsukasa, which is located in Niigata, has prospered along with it.`,
          breweryDescTitle: `A brewery known as a hub for promoting Japanese sake.`,
          breweryUrl: `https://www.imayotsukasa.com/pages/aboutus`,
          breweryUrlTitle: `Source: Imayo Tsukasa Sake Brewery Co. Ltd. official website`,
          characteristic: `Portraying Japan's charms through a collaboration between the nishikigoi and Japanese sake. \nThis sake is recommended to give as a gift and has won an award for its design.`,
          ingredients: `Rice (Produced in Japan), Rice Malt (Rice produced in Japan)`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5,600`,
          productDesc: `"Nishikigoi" is a sake that is gorgeous like Nishikigoi colored carp, and it has a pure and dignified taste.\nAs an antithesis to the modern world where more and more people drink with their mind,\nthe specifications of the sake are not disclosed.\nThis is a new type of sake that you can enjoy purely with your nose, mouth, and eyes, rather than just capturing the taste and aroma with your mind.`,
          productName: `Imayo Tsukasa "Nishikigoi" in a box 720 mL`,
          productionArea: `Niigata Prefecture`,
          recommendedWayToDrink: `Cold sake`,
          storageMethod: `A cool, dark place that doesn't experience a difference in temperatures.\nRefrigeration is recommended for long-term storage.`,
          typeOfSake: `Undisclosed`
        },
        mizubasho: {
          alcoholContent: `13`,
          brandName: `MIZUBASHO`,
          brewery: `Nagai Sake`,
          breweryDesc: `Founded in 1898. We are challenging the world with a new style of sake brewed from the nature and rice culture that our Japanese ancestors cherished.`,
          breweryDescTitle: `A brewery that proposes new possibilities for sake`,
          breweryUrl: `https://nagai-sake.co.jp/`,
          breweryUrlTitle: `Source: Nagai Sake Inc. official website`,
          characteristic: `It was complete after 10 years of planning and hundreds of trials and errors. A sparkling sake made using the same method as champagne.`,
          ingredients: `Rice (Produced in Japan), Rice Malt (Rice produced in Japan)`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5255`,
          productDesc: `Features fine bubbles with a gorgeous, elegant taste like champagne. An authentic sparkling sake that incorporates secondary fermentation within the bottle in the traditional sake manufacturing method. Top chefs around the world are astonished with this masterpiece of a sake, saying it has a texture they've never experienced before. It has the flavor of cherry and lychee, and the silky bubbles envelop the food like a fairy.`,
          productName: `MIZUBASHO PURE 720mL`,
          productionArea: `Gunma Prefecture`,
          recommendedWayToDrink: `Cold sake`,
          storageMethod: `A cool, dark place that doesn't experience a difference in temperatures.\nRefrigeration is recommended for long-term storage.`,
          typeOfSake: `Sparkling sake`
        },
        otherRecommendation: {
          moreRecommendedSake: `Check out more recommended sakes`
        },
        sakeIntro: {
          classBasics: `Specially designated sake is more particular about the ingredients than regular sake and is divided into classes based on (1) the rice polishing ratio (how much it is polished), (2) whether it is made using ginjo brewing, and (3) whether it contains distilled alcohol.`,
          daiginjo: `Daiginjo sake`,
          forBeginner: `When you first start drinking sake, many people find that they don't like its unique flavor, so if you're new to sake, we recommend a type of sake with a low rice polishing ratio.`,
          futsushu: `Regular sake`,
          ginjo: `Ginjo sake`,
          honjozo: `Honzojo sake`,
          junmaiDaiginjo: `Junmai Daiginjo sake`,
          junmaiGinjo: `Junmai Ginjo sake`,
          junmaishu: `Junmai sake`,
          polishing: `In general, the lower the rice polishing ratio (more rice is shaved off), the more elegant the sake will be with fewer unpleasant flavors and a cleaner taste with a stronger aroma. By shaving a lot of rice, proteins and fats are removed, resulting in a clearer flavor.`,
          polishingRatioAnnotation: `*What is the rice polishing ratio? Rice polishing ratio is the percentage of rice that remains after polishing (when the surface layer is removed from brown rice) expressed as a percentage.`,
          title: `Types\n of Sake`,
          jozo: {
            ingredients: `Rice, Water, Rice Malt, Distilled Alcohol`
          },
          junmai: {
            ingredients: `Rice, Water, Rice Malt`
          }
        },
        shochikubai: {
          alcoholContent: `15`,
          brandName: `Sho Chiku Bai`,
          brewery: `TAKARA SHUZO`,
          breweryDesc: `The blessings of the fields, nurtured by nature such as the fertile land and the abundant sunlight and rain, have been respected as irreplaceable treasures. We are particular about quality, appreciate the blessings of nature, and make our product with care.`,
          breweryDescTitle: `A long-established sake brewery in Fushimi, Kyoto`,
          breweryUrl: `https://www.takarashuzo.co.jp/takarahatakara/`,
          breweryUrlTitle: `Source: TAKARA SHUZO CO., LTD.`,
          characteristic: `A brand made by a long-established manufacturer that takes advantage of the celebratory "Sho Chiku Bai" concept.`,
          ingredients: `Rice (Produced in Japan), Rice Malt (Rice produced in Japan)`,
          netContent: `1,800mL`,
          polishingRatio: `0`,
          price: `5317`,
          productDesc: `Sho Chiku Bai Honjozo-shu sake is packaged in a square keg, a traditional container used for celebrations, and is characterized by its light and smooth taste.`,
          productName: `Sho Chiku Bai "Celebration Barrel" 1.8 L`,
          productionArea: `Kyoto Prefecture`,
          recommendedWayToDrink: `Lukewarm / Hot Sake`,
          storageMethod: `A cool, dark place that doesn't experience a difference in temperatures.\nRefrigeration is recommended for long-term storage.`,
          typeOfSake: `Honjozo`
        }
      }
    }
  },
  question: {
    answerCount: (count: number) => `Answer (${count})`,
    answerReceived: `Response received.`,
    answerUsefulThings: `Let's answer some useful and true thoughts`,
    askEveryone: `Let's ask everyone`,
    assistOthers: `Please assist other user with answering their question。`,
    completed: `Completed`,
    mayBeDeleted: `*Please note that if your question or answer is inappropriate, it may be deleted by the WAmazing Tax Free Shopping Operator.`,
    notifiedViaEmail: `You will be notified of the answer to your question via the email you receive.\n`,
    post: `Submit`,
    postDetailedQuestion: `Post a detailed question and you will receive a more accurate answer.`,
    postQuestion: `Submit a question`,
    questionsMayBeAnsweredByWAmazing: `Questions submitted may be answered by a WAmazing representative.`,
    received: `Question received.`,
    responseWillBeNotified: `Your response will be notified to the inquirer.`,
    thankYouForAnswer: `Thank you very much for your contribution in useful information!`
  },
  questionnaire: {
    aboutTheSurvey: `About the survey`,
    afterYouPicked: (answer: string, coupon: string) =>
      `※After you pick up your purchases, you will receive a <span class=${coupon}>JPY1000 coupon</span> <span class=${answer}>if you answer a survey</span>.`,
    answer: `Answer`,
    answerAfterPaid: `Alternatively, you can answer the survey from the email sent to you after the remaining balance is paid`,
    answerFromOrder: `Answer from the order information screen`,
    coupon: (className?: string) => `<span class=${className}>JPY 1000</span> coupon!`,
    fiveSecond: `5-second`,
    get: `GET`,
    pickUpCompleted: `Purchase pick-up completed`,
    popup: (url: string, className: string) =>
      `Please fill out the\n<a href=${url} class=${className} target='_blank'>Shopping Survey！</a>`,
    survey: `Survey`
  },
  questionnaireModal: {
    fiveSecond: `Take a quick 5-second survey`,
    getCoupon: `and get a JPY 1000 coupon!`,
    todayNotShow: `Do not display today`
  },
  ranking: {
    description: `Ranking list of popular items. If you are looking to purchase Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectioneries.`,
    popular: `Ranking`,
    title: `Ranking of hot items`,
    titleName: `Ranking`,
    meta: {
      title: `Ranking of Popular Japanese Products`
    }
  },
  receive: {
    vjwRegistrationInfo: `<div class="text-sm mt-2.5">To receive your items tax-free at designated facilities, <span class="text-primary">you must register for VJW (Visit Japan Web) after entering Japan.</span></div>`,
    detail: {
      address: `Address`,
      counterDescription: `Complete the process and pick up your items in person at hotels and other locations in Japan.`,
      lockerDescription: `Easily collect your items from unmanned lockers at airports, train stations, and bus terminals across Japan.`,
      map: `Map`,
      notRequired: `Not required`,
      pickupAvailableTime: `Available pickup times`,
      pickupLocationDetail: `Pickup Location Details`,
      pickupLocationInfo: `Pickup location information`,
      receiveAtCounter: `Pick up in person`,
      receiveAtLocker: `Pick up from lockers`,
      required: (url: string) =>
        `Required (<a class="underline" href=${url} target="_blank" rel="noopener noreferrer">Check the registration method</a>)`,
      view: `View Details`,
      viewOnMapApp: `Open in Maps app`,
      vjwRegistration: `Visit Japan Web registration`,
      vjwRequiredNote: `*Visit Japan Web registration required`
    },
    list: {
      pickupLocation: `Pickup location`,
      popularRegions: `Popular areas`,
      selectPickupLocation: `Select a pickup location`
    },
    navigation: {
      backToPickupList: `Return to list of\n pickup locations`,
      next: `Next`,
      select: `Select`
    },
    vjw: {
      counterInfo: (url: string) =>
        `・To complete tax-free procedures through face-to-face pickup, <span class="text-primary font-medium">you must register for <a href=${url} target="_blank" rel="noopener noreferrer" class="underline">VJW (Visit Japan Web)</a> after entering Japan</span>.`,
      pleaseCheck: `Please Be Sure to Check`,
      registrationRequired: `■Register for Visit Japan Web`
    }
  },
  recommended: {
    description: `Discover a curated list of popular Japanese products chosen by the WAmazing Shop. If you're in search of Japanese souvenirs, be sure to explore the WAmazing Shop. You can conveniently pick up your purchased items at designated airports during your trip to Japan. We offer an extensive array of popular Japanese cosmetics and confectionery.`,
    mustBuyPopularJapaneseGoods: `Must-buy popular Japanese goods`,
    popularJapaneseCosmetics: `Popular Japanese skincare, cosmetics`,
    popularJapaneseSnacks: `Popular Japanese sweets, snacks`,
    popularProducts: `Recommended Popular Products`,
    title: `List of Recommended Japan Tax Free Products`,
    viewMorePopularCosmetics: `View more popular skincare products, cosmetics`,
    viewMorePopularSnacks: `View more popular sweets, snacks`,
    cosmetics: {
      description: `WAmazing Shop offers a wide variety of snacks and other popular Japanese snacks. You can find the products you want on the site and buy them all at once! This is perfect for those who want to save time when selecting souvenirs. Purchased items can be picked up at designated airports and locations. This saves you from carrying large luggage, making your trip to Japan even more comfortable.`
    }
  },
  recommendedArticles: {
    title: `Recommended Articles`
  },
  referral: {
    label: `TODO: referral.label@en`,
    pageDescription: `TODO: referral.pageDescription@en`,
    pageTitle: `TODO: referral.pageTitle@en`,
    startShopping: `TODO: referral.startShopping@en`
  },
  registerCampaign: {
    campaignInProgress: `Campaign in progress`,
    entryAndRegister: `Click here to register`,
    fiveHundredOff: (border: string, thousand: string, yen: string, off: string) =>
      `<span class=${border}><span class=${yen}>JPY</span><span class=${thousand}>500</span></span><span class=${off}>OFF</span>`,
    fiveHundredOffForBanner: (discount: string, coupon: string) =>
      `<span class=${discount}>JPY 500</span><span class=${coupon}>OFF Coupon</span>`,
    getCouponByEntryAndRegistration: `Click here to register\nand recieve coupons!`,
    signUpAndGetCoupon: (className: string) => `Sign up and <span class=${className}>get a JPY 1,000 coupon</span> now!`
  },
  reviewSubmit: {
    button: `Post review`,
    howLike: `How did you like this product?`,
    optional: `Optional`,
    pleaseLogin: `Please log in first to review.`,
    required: `Required`,
    thanksForReview: `Thank you for posting your review`,
    guide: {
      agree: (button: string) => `I agree to the ${button} for posting a review`,
      button: `terms and conditions`,
      content: `• When using the review posting function, please understand the following purposes before posting a review.\n• It should be a place where contributors can subjectively evaluate the product, set a rating score and post a review.\n• Be a place to collect information on reviews based on the contributor's experience.\n• Please try to avoid using extra characters, spaces, hiragana, body text with lots of ASCII art, and line breaks.\n• You must not post reviews that contain any of the following information. If any of the following information is posted, we reserve the right to delete or edit the review or take any other action we deem necessary.\n　•Content that infringes or may infringe the copyright, honor, privacy, portrait rights, or other rights of our company, service providers, or third parties\n　• Content that discriminates against, slanders, or defames us, our service providers, or third parties, or that is libelous or defamatory\n　• Content that leads to or encourages criminal activity\n　• Content contrary to laws and regulations or public order and morals\n　• Content that includes commercial advertising purposes\n　• Content containing specific political or religious claims\n　• Content containing discriminatory expressions\n　•Content that is obscene, harmful, indecent, or otherwise objectionable to third parties\n　•Other contents that we deem inappropriate\n• Reviews will be translated into each language and posted on the WAmazing Shopping page. We will decide whether or not to post the reviews on the page.\n• We may freely reprint, quote, disclose, provide, publish, distribute, or otherwise use the content of posted reviews without charge and without notice to the reviewer.　In addition, the reviewer agrees not to exercise moral rights in the review against us or our designees.\n• We may delete or hide the content of a posted review without notice to the reviewer. In this case, we shall not be obliged to explain the reason for deletion or hiding.\n• The reviewer is solely responsible for the content of said review, and we are not responsible for the accuracy, reliability, legality, completeness, usefulness, or any other matters related to the content of the review.\n• Inquiries, complaints, claims, and other problems related to posted reviews shall be resolved by the reviewer at his or her own responsibility and expense, and shall not cause any trouble to our company.\n• Matters not stipulated in these notes shall be subject to the WAmazing Terms of Service, and the handling of personal information shall be subject to the Privacy Policy.`,
      title: `Notes`
    },
    label: {
      comment: `Comment`,
      nickname: `Nickname`,
      title: `Title`
    },
    placeholder: {
      comment: `Enter the comment here`,
      name: `Please enter the name to be displayed`,
      title: `Enter the title here`
    }
  },
  reviewSummary: {
    anonymous: `Anonymous`,
    count: (count: number) => `${count}`,
    productName: (productName: string) => `Review of  ${productName}`,
    reviewCount: (count: number) => `${count}reviews`,
    shareReview: `Share this product information with everyone!`,
    showOriginal: `Show original text`,
    showTranslated: `Show translated text`,
    title: `Review`,
    userName: (userName: string) => `Ms/Mr ${userName}`,
    age: {
      fifty: `50s`,
      forty: `40s`,
      sixty: `60s and above`,
      ten: `10s and under`,
      thirty: `30s`,
      title: `Age`,
      twenty: `20s`
    },
    gender: {
      female: `Female`,
      male: `Male`,
      other: `Do not specify`,
      title: `Gender`
    }
  },
  sakeNotice: {
    text1: `age verification`
  },
  search: {
    brandOrProductOrProduct: `Brand, Product Name, Model etc.`,
    enterKeywordsAlert: `Please enter a keyword such as product name you wish to search for.`,
    history: `Search history`,
    keyword: `Keywords`,
    noResultFor: (keyword: string) =>
      `No products matching '${keyword}' were found.\nIf the keyword was entered correctly but no matches were found, please try a different word.`,
    popularKeywords: `Popular Keywords`,
    recommendedKeywords: `Recommended Keywords`,
    search: `Search`,
    searchItems: `Search Items`,
    searchResultFor: (keyword: string) => `Search Results of '${keyword}'`,
    searchingFor: (keyword: string) => `Searching '${keyword}'`,
    meta: {
      description: `If you are looking to purchase Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide selection of popular Japanese cosmetics and confectionery.`,
      title: `Search Results`
    }
  },
  service: {
    useFreeECshopTitle: `Terms of Use for WAmazing Tax Free EC Service`
  },
  shops: {
    commonMapDescription: (className: string) =>
      `* Orders can be placed <span class=${className}>up to 3 months before the date of receipt </span>.\n* <span class=${className}>Can be purchased before leaving for Japan. </span>\n* The displayed time is Japan time.`,
    list: `List of Pickup Location `,
    mapTitle: `Pickup location guide`,
    pickupAvailableDates: `Pick-up dates`,
    placeholder: `Select pickup location`,
    centrair_shop: {
      listPickupLocation: `Chubu Centrair International Airport - Access Plaza 2F`,
      lockersLocation: `Chubu Centrair International Airport Pickup Map`,
      routeInformationByBusTaxi: `Directions (for those taking a bus or cab)`,
      routeInformationByTrain: `Directions (for those taking the train)`,
      route: {
        busTaxi: {
          step1: `① After getting off, please go up to the 2nd floor of Terminal 1 and head in the direction of the Access Plaza.`,
          step2: `② Enter the Access Plaza and continue straight ahead.`,
          step3: `③ Go straight along the road to the far end.`,
          step4: `④ The tax-free lockers are located in the booth at the far end.`,
          step5: `⑤ WAmazing's tax-free lockers are in front of you. \nExperience fun and easy tax-free shopping!`
        },
        train: {
          step1: `① After getting off, exit the ticket gate and proceed left.`,
          step2: `② Go straight along the street.`,
          step3: `③ The tax-free lockers are located in the booth at the far end.`,
          step4: `④ WAmazing's tax-free lockers are in front of you. \nExperience fun and easy tax-free shopping!`
        }
      }
    },
    hakata_station_shop: {
      listPickupLocation: `Pick-up Map for JR Hakata Station`,
      lockersLocation: `Inside Hikari Square on the 2nd floor`,
      routeInformationByBulletTrain: `Directions (For those using Shinkansen Hakata Station)`,
      routeInformationByCar: `Directions (for those using a car)`,
      routeInformationByJR: `Directions (For those using JR Hakata Station)`,
      route: {
        finish: (number: string) =>
          `${number} You will see the WAmazing Shop Tax-Free Pick-up Lockers.\nHave a fun and easy tax-free shopping experience!`,
        bulletTrain: {
          step1: `① Exit the ticket gate and proceed to the left side of the coffee shop in front of you.`,
          step2: `② You will see the lockers on the left.`
        },
        car: {
          step1: `① Proceed to the right as soon as you enter the entrance.`,
          step2: `② Take the escalator on the right to the second floor.`,
          step3: `③ Get off on the second floor and proceed forward to the right.`,
          step4: `④ You will see the lockers on the left.`
        },
        jr: {
          step1: `① Exit the ticket gate and proceed to the right of the ticket office.`,
          step2: `② Continue straight ahead.`,
          step3: `③ Take the escalator on the left to the second floor.`,
          step4: `④ Get off on the second floor and proceed forward to the right.`,
          step5: `⑤ You will see the lockers on the left.`
        }
      }
    },
    haneda_shop: {
      listPickupLocation: `Pickup Map at Haneda Airport Terminal 3`,
      lockersLocation: `Tokyo Monorail Haneda Airport Terminal 3 Station Floor Plan`,
      lockersLocationNotice: `*Please check with the Airport Information Counter if you would like to use the elevator.`,
      routeInformationByBusTaxi: `Directions (for those taking a bus or cab)`,
      routeInformationByKeikyu: `Directions (for those using the Keikyu Line)`,
      routeInformationByMono: `Directions (for monorail users)`,
      route: {
        busTaxi: {
          step1: `① From the 1st floor platform, please go up to the arrival lobby on the 2nd floor and head for the monorail station on the 2nd floor.`,
          step2: `② After purchasing a 180 yen admission ticket from the monorail ticket machine, enter the ticket gate.`,
          step3: `③ When you enter the ticket gate, there is a WAmazing pickup locker on your left. Experience fun and easy tax-free shopping!`
        },
        keikyu: {
          step1: `① After getting off, head towards the exit and exit through the ticket gate.`,
          step2: `② Go straight and take the escalator in front of you on the left and go up to the 2nd floor.`,
          step3: `③ Exit the elevator and turn left following the sign in the arrival lobby on the 2nd floor.`,
          step4: `④ Follow the signs in the arrival lobby straight ahead, and you will see the monorail station. Take a detour and head in the direction of the monorail.`,
          step5: `⑤ After purchasing a 180 yen admission ticket from the monorail ticket machine, enter the ticket gate.`,
          step6: `⑥ When you enter the ticket gate, there is a WAmazing pickup locker on your left. Experience fun and easy tax-free shopping!`
        },
        mono: {
          step1: `① After getting off, head towards the exit and take the escalator to the 2nd floor.`,
          step2: `② Turn left along the street.`,
          step3: `③ WAmazing's tax-free lockers are in front of you. \nExperience fun and easy tax-free shopping!!`
        }
      }
    },
    hiroshima_shop: {
      listPickupLocation: `Hiroshima Airport Pick-up Information Map`,
      lockersLocation: `International Departure Lobby on the 2nd floor`,
      routeInformationByBus: `Directions (For those arriving at Hiroshima Airport Station via bus)`,
      routeInformationByInternational: `Directions (from International Arrivals)`,
      route: {
        bus: {
          step1: `1) Get off the bus, take the escalator and proceed to the International Departure Lobby on the right side of the 2nd floor.`,
          step2: `2) Proceed through Soramy Square (Atrium) in the middle, in the direction of the "Currency Exchange" store on the right side.`,
          step3: `3) You will see the lockers on the left side of the Currency Exchange store`,
          step4: `4) You will see the WAmazing Shop Tax-Free Pick-up Lockers.\nHave a fun and easy tax-free shopping experience!`
        },
        international: {
          step1: `1) After arriving at international arrivals, take the escalator in the arrival hall to the 2nd floor and then turn left.`,
          step2: `2) Proceed in the direction of the Currency Exchange store on the right and you will see the lockers on the left.`,
          step3: `3) You will see the WAmazing Shop Tax-Free Pick-up Lockers.\nHave a fun and easy tax-free shopping experience!`
        }
      }
    },
    kansai_shop: {
      listPickupLocation: `Map of JR Kansai Airport Station`,
      lockersLocation: `Map showing locations of lockers at Kansai Airport`,
      routeInformationByJR: `Route information (for those using JR line)`,
      routeInformationByOthers: `Route information (for those using transportation other than JR line)`,
      route: {
        jr: {
          step1: `(1) After getting off the train, please go up to the 2nd floor (ticket gate floor) from the platform.`,
          step2: `(2) When you go up to the 2nd floor of the ticket gate, you will see a large map. Continue on past the left of the map. `,
          step3: `3) Continue forward and you will see an ATM in front of you. Please go around behind it.`,
          step4: `(4) Go behind the ATM and you will see the WAmazing tax-free free lockers. It's a fun, effortless tax-free shopping experience! `
        },
        others: {
          step1: `(1) Upon arrival at Kansai International Airport Terminal 1, please head to "JR Kansai Airport Station" on the 2nd floor. `,
          step1note: `*For limousine bus users: Upon arrival at the international departure floor on the 4th floor of the Terminal 1 Building, please go down to the 2nd floor.\n*For those using a ferry: Upon arrival at the port terminal of Kansai Airport, please take the dedicated shuttle bus and get off at the 2nd floor when you arrive at the international departure floor on the 4th floor of the Terminal 1 Building.`,
          step2: `(2) At the subway ticket counter, head for the JR ticket counter in the blue signboard area on the right side.`,
          step3: `Please purchase a ticket for 150 yen at the ticket machine and enter the JR ticket gate behind you.`,
          step4: `(4) When you enter the ticket gate, you will see a large map in front of you. Go to the front left of the map. `
        }
      }
    },
    mapDescription: {
      centrair_shop: (className: string) =>
        `WAmazing's tax-free lockers are located on the <span class=${className}>2nd floor of the Access Plaza at Chubu Centrair International Airport</span>.`,
      hakata_station_shop: (className: string) =>
        `WAmazing pickup lockers are located inside <span class=${className}>Hikari Square on the 2nd floor</span> of JR Hakata Station.\n`,
      haneda_shop: (className: string) =>
        `WAmazing pickup lockers are located inside the <span class=${className}>Monorail Ticket Gate</span> on the arrival floor of Haneda Airport Terminal 3 (2nd floor).\n\n<span class=${className}>*We recommend using the monorail\n*Please purchase a separate ticket to enter the station if you are not using the monorail.</span>`,
      hiroshima_shop: (className: string) =>
        `WAmazing's pick-up lockers are located in the <span class=${className}>International Departure Lobby on the 2nd floor of Hiroshima Airport</span>.`,
      kansai_shop: (className: string) =>
        `WAmazing retrieval lockers are located on the 2nd floor inside the ticket gates of<span class=${className}> "JR Kansai Airport Station". </span>\n\n<span class=${className}>*We recommend using the JR line.\n*Please purchase a separate ticket to enter the station for those who are not using the JR line.\n</span>`,
      naha_station_shop: (className: string) =>
        `WAmazing lockers are located at <span class=${className}>the "Free Power Socket Corner" on the 2nd floor</span> of Naha Airport.`,
      narita1_shop: (className: string) =>
        `WAmazing's tax-free lockers are located at <span class=${className}>Narita Airport Terminal 1 (JR Narita Airport Station)</span>.\n\n*We recommend using <span class=${className}>JR East trains</span>. Please get off at <span class=${className}>Narita Airport Station</span>.`,
      narita2_shop: (className: string) =>
        `WAmazing's tax-free lockers are located at <span class=${className}>Narita Airport Terminal 2 (JR Airport Terminal 2 Station)</span>. \n\n*We recommend using <span class=${className}>JR East trains</span>. Please get off at <span class=${className}>the Airport Terminal 2 Station</span>.`,
      new_chitose_shop: (className: string) =>
        `WAmazing's tax-free lockers are located on <span class=${className}>the 1st floor of New Chitose Airport International Terminal</span>.\n\n*The lockers are located about <span class=${className}>10 minutes</span> from JR station. Please allow plenty of time for pickup.`,
      sendai_shop: (className: string) =>
        `<span class=${className}>The International Arrivals Lobby on the first floor</span> of Sendai International Airport has WAmazing lockers to pick up your purchases.`,
      tenjin_shop: (className: string) =>
        `WAmazing tax-free lockers are located on the 3rd floor of <span class=${className}>the Tenjin Bus Terminal by the drop-off area</span>.\n\n\n*We recommend using <span class=${className}>Nishi-Nippon Railway (Nishitetsu)</span>. Please get off at <span class=${className}>Nishitetsu Tenjin Station</span>.`
    },
    messages: {
      earliestPickupDate: `Earliest collection date`,
      minimumPickUpTime: (year: string, month: string, day: string, hour: string, minute: string, className: string) =>
        `Receive as early as <span class=${className}>${month} ${day}, ${year},  ${hour}:${minute}</span>`,
      minimumPickUpTimeSp: (
        year: string,
        month: string,
        day: string,
        hour: string,
        minute: string,
        className: string
      ) => `<span class=${className}>Pickup At</span><span> ${month}, ${day}, ${year},  ${hour}:${minute}</span>`
    },
    naha_shop: {
      listPickupLocation: `Naha Airport Pick-up Map Guide`,
      lockersLocation: `Naha Airport 2F`,
      routeInformationByDomestic: `Route Guide (from the domestic terminal)`,
      routeInformationByInternational: `Route Guide (from the international terminal)`,
      route: {
        domestic: {
          step1: `① Proceed toward the international departures gate D on the 2nd floor.`,
          step2: `② Turn left in front of gate D. You will see the restroom nearby.`,
          step3: `③ At the end of the hall, turn to the left and you will find a locker.`
        },
        international: {
          step1: `① Proceed toward the Visitor Service Center. Take the escalator on the right and proceed to the 2nd floor.`,
          step2: `② Turn to the left immediately after getting off the escalator and you will find the WAmazing lockers.`
        }
      }
    },
    narita1_shop: {
      listPickupLocation: `Pickup Map for Narita Airport Station`,
      lockersLocation: `Information Map for Narita Airport Station`,
      routeInformationByJR: `Directions (for those using JR East Narita Airport Station)`,
      routeInformationByKeisei: `Directions (for those taking the Keisei Line)`,
      route: {
        finish: (routeNumber: string) => `${routeNumber}Experience fun and easy tax-free shopping!!`,
        busTaxi: {
          step1: `①After getting off the train, proceed toward the JR ticket gate.`,
          step2: `②After purchasing a JPY 150 admission ticket from a JR ticket vending machine, go through the ticket gate.`,
          step3: `③Head toward the waiting room and you'll find the WAmazing lockers on your right.`
        },
        jr: {
          step1: `①After getting off the train, take the escalator up.`,
          step2: `②Proceed toward the exit.`,
          step3: `③WAmazing lockers are located on the left toward the exit.`
        },
        keisei: {
          step1: `①After getting off the train, take the escalator up to the exit.`,
          step2: `②Take the exit and turn left toward the JR ticket gate.`,
          step3: `③After purchasing a JPY 150 admission ticket from a JR ticket vending machine, go through the ticket gate.`,
          step4: `④Head toward the waiting room and you'll find the WAmazing lockers on your right.`,
          ticket: `*How to purchase tickets\nNote: After you receive your items and exit the ticket gate, please tell the station staff that you used it as an admission ticket.`
        }
      }
    },
    narita2_shop: {
      listPickupLocation: `Pickup Map for Narita Airport Terminal 2 Station`,
      lockersLocation: `Information Map for Narita Airport Terminal 2 Station`,
      routeInformationByJR: `Directions (for those using the JR East Airport Terminal 2 Station)`,
      routeInformationKeisei: `Directions (for those taking the Keisei Line)`,
      route: {
        busTaxi: {
          step1: `①After getting off the train, proceed toward the JR ticket gate.`,
          step2: `②Proceed to the JR ticket gate and purchase an admission ticket at the ticket office.`,
          step3: `③Enter the JR ticket gate and the WAmazing lockers are on the right side facing the restrooms.`
        },
        jr: {
          step1: `①After getting off the train, take the escalator up.`,
          step2: `②Please proceed towards the restroom on the opposite side of the ticket gate.`,
          step3: `③WAmazing lockers are located on the right side facing the restrooms.`
        },
        keisei: {
          step1: `①After getting off the train, take the escalator up.`,
          step2: `②Exit the ticket gate and turn left.`,
          step3: `③Head toward Terminals 2 and 3.`,
          step4: `④Proceed to the JR ticket gate and purchase an admission ticket at the ticket office.`,
          step5: `⑤Enter the JR ticket gate and the WAmazing lockers are on the right side facing the restrooms.`,
          ticket: `*Sample image of an admission ticket`
        }
      }
    },
    new_chitose_shop: {
      listPickupLocation: `Pickup Map for New Chitose Airport`,
      lockersLocation: `New Chitose Airport- 1F`,
      routeInformationByBusTaxi: `Directions (for those taking a bus or taxi)`,
      routeInformationByTrain: `Directions (for those taking the train)`,
      route: {
        busTaxi: {
          step1: `(1) After getting off the train, please enter the terminal building and follow the "International Flights" sign as you go up to the 2nd floor.`,
          step2: `(2) Continue to follow the "International Flights" sign and go straight to the end of the walkway.`,
          step3: `(3) At the end of the walkway, please turn left and proceed.`,
          step4: `(4) After passing the convenience store, turn right at the end of the walkway.`,
          step5: `(5) Use the elevator at the end of the walkway and go down to the 1st floor.`,
          step6: `(6) Go down to the elevator and head to the front left.`,
          step7: `(7) Go straight ahead and the WAmazing tax-free lockers will be on your right. Have a fun and effortless tax-free shopping experience!`
        },
        train: {
          step1: `(1) After getting out of the car, go out of the ticket gate and immediately use the elevator in front of you to go up to the 2nd floor.`,
          step2: `(2) Exit the elevator and go straight towards the sign for "International Flights."`,
          step3: `(3) Head for the "International Flights" sign and go straight to the end of the street.`,
          step4: `4) At the end of the street, please turn left and proceed.`,
          step5: `(5) After passing the convenience store, turn right at the end of the street.`,
          step6: `(6) Use the elevator at the end of the walkway and go down to the 1st floor.`,
          step7: `(7) Go down to the elevator and head to the front left.`,
          step8: `(8) Go straight ahead and the WAmazing tax-free lockers will be on your right. Have a fun and effortless tax-free shopping experience!`
        }
      }
    },
    notice: {
      aboutOrder: `Please purchase in advance as it takes at least 3 days to deliver.`
    },
    sendai_shop: {
      listPickupLocation: `Map of pick-up locations at Sendai International Airport`,
      lockersLocation: `1F International Arrivals Lobby`,
      routeInformationByInternational: `Directions (from the international terminal)`,
      routeInformationUseSdj: `Directions (for those arriving via Sendai Airport Station)`,
      route: {
        international: {
          step1: `① Immediately after international arrivals, there are lockers located on the left of the exit.`
        },
        sdjInternational: {
          step1: `① Proceed to the passage on the right immediately after exiting the ticket gate.`,
          step2: `② Go to the end of the passage and turn left as indicated on the bulletin board.`,
          step3: `③ Proceed to the far end of the passage and proceed to the exit on the right.`,
          step4: `④ Take the escalator on your right and go down to the first floor.`,
          step5: `⑤ Go down to the first floor and proceed to the international arrival lobby on the left.`,
          step6: `⑥ Lockers are located on the left side at the end.`
        }
      }
    },
    tableHeader: {
      receivableDate: `Earliest collection date`,
      shopName: `Pickup Location Name`
    },
    tenjin_shop: {
      listPickupLocation: `Tenjin Bus Terminal- 3F`,
      lockersLocation: `Tenjin Bus Terminal Pick-up Information Map`,
      routeInfomation: `Route guidance (for those using Nishitetsu Tenjin Station).`,
      route: {
        step1: `(1) After getting off the train, exit through the north ticket gate and turn left.`,
        step2: `(2) Follow the "Express Bus (Arrival)" sign in the direction of the drop-off area.`,
        step3: `(3) Use the elevator to go up to 3F.`,
        step4: `(4) Exit the lift and head in the opposite direction. (Pass through the Information).`,
        step5: `(5) Continue straight ahead and you will see the WAmazing lockers at the end.`,
        step6: `(6) Experience fun and easy tax-free shopping!!`
      }
    }
  },
  staticWalkthrough: {
    description: `WAmazing Shop Introduction Page\nIf you are looking to purchase Japanese souvenirs, please visit the WAmazing Shop. Purchased items can be picked up at designated airports during your trip to Japan. We have a wide variety of popular Japanese cosmetics and snacks.`,
    heading: `About the WAmazing Shop`,
    pickupsSectionHeading: `Pickup Location Name`,
    safeAndConveneientShoppingService: (className: string) =>
      `A "safe and convenient tax-free shopping service" where you can shop online and then <span class=${className}>retrieve at a designated airport in Japan</span>.`,
    serviceBenefitsHeading: `Why use our service..?`,
    serviceBenefitsSubheading: `Shop with ease without the hassle of carrying around your shopping. Make the most of your limited time and enjoy Japan more.`,
    title: `Service Introduction`,
    aboutPurchase: {
      btn: `Check 'Japan's Tax Exemption System'`,
      heading: `About tax-free shopping`,
      listItem1: `・Tax exemption is possible for purchases above JPY 5,000 (excluding tax) \n`,
      listItem2: `・Tax exemption is reserved to temporary visitor visa holders only\n`,
      listItem3: `・One person can purchase up to JPY 500,000 of tax-free items per day`,
      listItem4: `・Please order 3 days in advance of the pick-up date.`
    },
    banner: {
      banner1: {
        text: `Recommended popular cosmetics`,
        title: `Official vendor of famous brands`
      },
      banner2: {
        text: `Recommended popular sweets`,
        title: `The best Japanese sweets`
      }
    },
    faqs: {
      answer1: `Yes, the pick-up date is not limited to the departure date. `,
      answer2: `Payments can only be made online. Visa, Mastercard, JCB, and American Express are now accepted.\nWeChatPay users can pay with WeChatPay for the remaining payment amount when retrieving items.`,
      answer3: `You cannot change the pick-up date. You will need to cancel the order and purchase again. `,
      answer4: `・Make sure you have an active internet connection to complete payment. \n・The person who made the order must come to the pickup location in person to complete the transaction. \n・The person who made the order must bring their passport (must be e-Passport) with a valid landing permit seal affixed to the passport.\n・The face of the person who made the order will be photographed. \n・Payment by credit card (Visa/Mastercard/JCB/American Express) is required when retrieving items. `,
      btn: `Check out all guides`,
      heading: `Frequently asked questions (FAQ)`,
      question1: `Can I retrieve my items on a day other than my departure date?`,
      question2: `Which payment methods do you accept?`,
      question3: `Can I change the pick-up date?`,
      question4: `What do I need to present when retrieving items?`
    },
    serviceBenefits: {
      issueLink: `"Retrieval problems" here`,
      card1: {
        body: (className: string) =>
          `Perfect for those who find it difficult to go through the tax exemption process because of <span class=${className}>stores with no tax-free shopping </span>, <span class=${className}> don't understand Japanese</span>, or <span class=${className}>have extra tax-free charges </span>.`,
        footer: `Easy order online`,
        title: `It's hard to find a store`
      },
      card2: {
        body: (className: string) =>
          `Perfect for those who got carried away shopping and then find it <span class=${className}>difficult to carry it all around</span> , have to <span class=${className}>ride trains</span> , or have to carry a purchase for someone else.`,
        footer: `It's easy because you receive it at the airport`,
        title: `Carrying shopping is difficult`
      },
      card3: {
        body: (className: string) =>
          `Perfect for those who find it difficult to go through the tax exemption process because of <span class=${className}>stores with no tax-free shopping, don't understand Japanese </span>, or <span class=${className}> have extra tax-free charges</span>.`,
        footer: `Verifying tax exemption is easy`,
        title: `Tax-free paperwork is stressful`
      },
      card4: {
        body: (className: string) =>
          `Perfect for those who <span class=${className}> still find crowded places stressful,</span> would prefer to <span class=${className}> avoid close-contact situations or unnecessary communication</span>, or<span class=${className}> reduce possible risks</span> .`,
        footer: `No  interact with staff.\nSafe and secure pickup. `,
        title: `Being around people is still stressful`
      },
      card5: {
        body: (className: string) =>
          `Perfect for those who feel <span class=${className}> restricted by shopping at places arranged by a tour agency</span>, or have <span class=${className}> no time for shopping </span>on a package travel itinerary.`,
        footer: `It's also perfect for package travel`,
        title: `No free time`
      },
      card6: {
        body: (className: string) =>
          `<span class=${className}>"It's a bit different. Is that the authentic product?"  </span> , it's a gift so I don't want to be embarrassed, I want to shop at an official vendor: if you worry about these things, this is perfect for you.  `,
        footer: `Guaranteed authentic brands`,
        title: `I worry what I bought is fake`
      },
      card7: {
        body: (className: string) =>
          `Perfect for those who are worried about possibly getting the dates or pick-up place wrong and thus<span class=${className}> not able to retrieve their items</span> . `,
        footer: `Full support and peace of mind`,
        title: `I worry if something comes up`
      }
    },
    serviceUsageFlow: {
      heading: `Service flow`,
      usageCard1: {
        body: `Easily find not only Japanese souvenirs, but also regional limited-edition goods from all over Japan online!`,
        title: `Shop online`
      },
      usageCard2: {
        body: `Book your desired items for 20% of their price!`,
        title: `Pay the reservation fee`
      },
      usageCard3: {
        body: `At the pick-up location, pay the remaining 80% and receive your shopping right after your tax-free status is confirmed! `,
        title: `Pay at the pick-up location\nand receive your shopping`
      }
    }
  },
  systemMaintenance: {
    text: `System maintenance is scheduled from 4:30 to 5:30 AM（JST）on September 26 (Thu.). During this time, the WAmazing Shop will be inaccessible both online and via the app.`
  },
  taxFreeGuide: {
    description: (className: string) =>
      `Japan is a country that offers much to see and do: sights, cuisine, fun places, and more. And with any trip abroad one of the perks is <span class=${className}>shopping at tax-free prices!</span> \nHowever, you might not be familiar with the process. <span class=${className}>Get to know your way around Japan's tax-free shopping</span> as part of an amazing trip.`,
    title: `Japan's tax-free Information`,
    TaxExemption: {
      heading: `Tax exemption in Japan `,
      Item1: {
        description: `Visitors with a short-term visa status (up to 6 months) are eligible for tax exemption. A passport with a valid landing permit sticker is required for tax exemption procedures. `,
        title: `Short-term visa holders are eligible for tax exemption `
      },
      Item2: {
        description: `The total amount of a single purchase must be at least JPY 5,000 (excluding tax). Consumable goods have a limit of up to JPY 500,000 (excluding tax) per day in the same store. `,
        title: `Tax exemption is possible For purchases of JPY 5,000 or more`
      },
      Item3: {
        description: `The tax rate is 8% for products subject to reduced tax rate.`,
        title: `The 10% consumption tax Is tax exempt`
      }
    },
    dutyFree: {
      description: `You can do tax-free shopping at online stores, drugstores, department stores or convenience stores that have the Tax-free shop mark.`,
      heading: `Which stores in Japan\nsell tax-free products? `,
      card1: {
        d1: `Tax-free procedures`,
        d2: `Online`,
        d3: `Social distancing`,
        d4: `Maintained`,
        d5: `Convenience`,
        d6: `Shipped to the airport\n`,
        description: (className: string) =>
          `Perfect if you think a communication barrier makes it <span class=${className}>difficult to find the store</span> selling what you want, you <span class=${className}>don't want your items to get wet</span> on a rainy day or you want to <span class=${className}>avoid waiting in line</span>. `,
        heading: `Online Shopping`
      },
      card2: {
        d1: `Tax-free procedures`,
        d2: `Possible`,
        d3: `Social distancing`,
        d4: `Face-to-face`,
        d5: `Convenience`,
        d6: `Must carry luggage`,
        description: (className: string) =>
          `Perfect if you feel <span class=${className}>inconvenienced carrying shopping around</span>, still have plans and need to <span class=${className}>board the train</span> or<span class=${className}>you need to buy for someone else</span> . `,
        heading: `Drugstores`
      },
      card3: {
        d1: `Tax-free procedures`,
        d2: `Time-consuming`,
        d3: `Social distancing`,
        d4: `Face-to-face`,
        d5: `Convenience`,
        d6: `Must carry luggage`,
        description: (className: string) =>
          `Perfect for you if you think tax-free procedures are complicated such as finding <span class=${className}>no tax-free service</span>, <span class=${className}>communicating with japanese-speaking staff,</span> or <span class=${className}>having tax-free service charges</span>.`,
        heading: `Department Stores`
      }
    },
    dutyFreeFlow: {
      heading: `Online tax-free shop\nPurchase flow`
    },
    dutyFreePrecautions: {
      heading: `About tax-free products in Japan`,
      info: `・Tax-free products that fall under the category of consumables cannot be opened and used in Japan.\n・Tax-free goods cannot be passed on to another person before leaving the country.\n・Liquids such as beverages, condiments, and cosmetics are subject to carry-on restrictions.\n・When shipping tax-free items overseas, you need to submit a copy of the acceptance receipt, shipping slip, etc. issued by the post office to customs.\n・Tax-free goods must be taken out of the country by the purchaser.`
    },
    faqs: {
      answer1: `(4) Go behind the ATM and you will see the WAmazing tax-free lockers. It's a fun, effortless tax-free shopping experience! `,
      answer2: `Your passport and the tax-free purchase. \n`,
      answer3: `No, you can't. Tax exemption is only possible on the day of purchase.`,
      answer4: `If you use the automated gates during passport control, your passport will not be stamped with the entry permit and you may not be able to complete tax-free procedures. If you use tax-free stores, inform the immigration office in advance that you require a stamp.`,
      answer5: `Carry-on liquids are limited to 100 ml or less. However, if you meet the following conditions, the items can be brought on board. \n・If you place them inside a suitcase and check-in at the luggage counter. \n・If you purchase the tax-free liquids inside the departure area (*direct flights only)`,
      answer6: `Only the person buying the tax-free items can apply for tax exemption. `,
      answer7: `Only the person who purchased the items is responsible for bringing them overseas. `,
      heading: `Tax-free procedures FAQ`,
      question1: `What is the difference between "DUTY FREE" and "TAX FREE"? `,
      question2: `What do you need when applying for tax exemption ? `,
      question3: `Can I apply for tax exemption after the day of purchase?`,
      question4: `Can I use the tax-free system when using the automated gate?`,
      question5: `Can I carry tax-free liquid items on board?`,
      question6: `Can another person perform the tax-free procedures on my behalf?`,
      question7: `Can I hand over the tax-free items to another person to bring overseas? `
    },
    meta: {
      description: `About tax-free procedures | About tax-free shopping | About tax-free stores in Japan 。 Buy Japanese souvenirs conveniently at great prices at WAmazing Shop!`,
      title: `Tax-Free Guide`
    },
    products: {
      description: `You can purchase tax-free items in all online shops, drugstores, department stores or convenience stores that have the Tax-free shop mark on them.  `,
      heading: `What's eligible for tax exemption in Japan?`,
      card1: {
        info: `*1 person eligible for tax exemption must spend a total of JPY 5,000 or more per day and per store.\n\n*Can be used in Japan, must be taken out of the country within 6 months after entry`,
        item1: `Accessories`,
        item2: `Clothes`,
        item3: `Bags`,
        item4: `Shoes`,
        item5: `Electric appliances`,
        item6: `Cameras`,
        item7: `Watches`,
        title: `General items`
      },
      card2: {
        info: `*1 person eligible for tax exemption must spend a total of JPY 5,000 or more per day and per store.\n*Can be used in Japan, must be taken out of the country within 6 months after entry`,
        item1: `Cosmetics`,
        item2: `Food`,
        item3: `Liquor`,
        item4: `Cigarettes`,
        item5: `Health supplements`,
        item6: `Pharmaceuticals`,
        title: `Consumable goods`
      }
    }
  },
  taxFreeShop: {
    article1: `Article 1 Application of Terms`,
    article10: `Article 10 Temporary Suspension of the Website. and the Tax Free EC Service`,
    article10Sentence1: `We may temporarily suspend the operation of the Website. and the Tax Free EC Service without prior notice to the members in any of the following cases:`,
    article10Sentence2: `(1) When we carry out maintenance or change the specifications of the Website;`,
    article10Sentence3: `(2) When we are unable to operate the Website. and the Tax Free EC Service due to the occurrence or possible occurrence of a natural disaster or other emergency; or`,
    article10Sentence4: `(3) When we decide that temporary suspension is needed for the operation of the Website. and the Tax Free EC Service due to unavoidable reasons.`,
    article11: `Article 11 Disclaimer`,
    article11Sentence1: `1. We will not have any responsibility for damages caused by a natural disaster, line congestion, stoppage of equipment due to failure or maintenance, or loss of information from the supplier of the goods, or falsification of or divulging information etc. by a third party, unless such damages are attributable to us.`,
    article11Sentence2: `2. Even if we are responsible to the member in relation to the use of the Tax Free EC Service, our responsibility will be limited to direct and normal damages except in the case of our willful misconduct or gross negligence.`,
    article12: `Article 12 Governing Law, Language and Jurisdiction`,
    article12Sentence1: `1. These Terms shall be governed by and construed in accordance with the laws of Japan.`,
    article12Sentence2: `2. The Japanese version of these Terms shall be deemed original and these Terms shall be construed and concluded in Japanese. Any translation of these Terms into another language is for reference purpose only, and shall not change the interpretation of these Terms in Japanese.`,
    article12Sentence3: `3. Any dispute arising in relation to these Terms shall be submitted to the Tokyo District Court as the court of exclusive jurisdiction in the first instance.`,
    article1Sentence1: `1. These terms of use for Tax Free EC Service (these “Terms”) apply to any act carried out by each of the members who have registered for the Tax Free EC Service (as defined in the following Article) membership through the smartphone application (WAmazing application) or website (collectively the “Website”) managed and operated by WAmazing, Inc. (“we”) when such member uses the Tax Free EC Service. Each of the members shall accept these Terms before using the Tax Free EC Service.`,
    article1Sentence2: `2. When there are notes, etc. that we present concerning the Tax Free EC Service (the “Notes, etc.”), each of the Notes, etc. will constitute a part of these Terms respectively.`,
    article1Sentence3: `3. We may change these Terms at any time without prior notice to the members, and the change will become effective when we post the changed Terms on our website  (or on the date we separately designate as the effective date of the changed Terms). When a member uses the Tax Free EC Service thereafter, it is deemed that the member has agreed to the changed Terms.`,
    article2: `Article 2 Definition of Tax Free EC Service and Completion of Sale and Purchase Reservation Agreement`,
    article2Sentence1: `1. The Tax Free EC Service means a service that allows each of the members to carry out the following through the Website:`,
    article2Sentence2: `・Purchasing and reserving for purchase the goods that we posted on the Website.`,
    article2Sentence3: `2. Each of the members may reserve the goods for purchase on the Website. in the following manner:`,
    article2Sentence4: `・A member will enter the necessary information designated by us (including information on the member, boarding information, order information and payment information, etc.) on the Website, and apply on the Website. for reserving the goods for purchase. The reservation will be completed when the reservation fee set forth in Article 4 has been paid. A sale and purchase reservation agreement (the “Reservation Agreement”) for the goods will be deemed to be concluded between the member and us when the reservation has been completed on the Website.`,
    article2Sentence5: `3. The period when a reservation can be made will be as shown on the Website.`,
    article2Sentence6: `4. In order to confirm the conclusion of the Reservation Agreement, we will deliver a “Reservation Agreement conclusion screen” to the member’s webpage in the Website.`,
    article2Sentence7: `5. When the Reservation Agreement is concluded between the member and us in accordance with the provisions of this Article, it is deemed that the member has accepted that the member will have obligations such as payment of the cancellation fee under Article 5.`,
    article3: `Article 3 Change of Price of Goods etc.`,
    article3Sentence1: `1. Each of the members agrees that the information on the price of goods, etc. posted on the Website. may be different from that provided through other media.`,
    article3Sentence2: `2. Each of the members agrees that the price of goods, etc. may be changed without prior notice. The changed price of goods, etc. will apply only to the member who applied for a reservation after the change, and the price of goods, etc. before the change will apply to the member who applied for a reservation before the change.`,
    article4: `Article 4 Payment of Reservation Fee for Goods`,
    article4Sentence1: `When a member reserves the goods for purchase, the member shall pay 20% of the price of the goods with us as a reservation fee(consumption tax included) unless otherwise provided for in the goods information etc.  The member shall not request a refund of the reservation fee until the member cancels or purchases the reserved goods.`,
    article5: `Article 5 Cancellation of the Reservation and Cancellation Fee`,
    article5Sentence1: `1. Each of the members may cancel all of the reservations for purchasing the goods reserved under the Reservation Agreement until the date of receipt designated by the member at the time of reserving the goods for purchase. However, in such case, the member shall cancel all of the reservations for purchasing the goods collectively, and shall not cancel a part of the reservations.`,
    article5Sentence2: `2. When a member cancels the reservation for purchasing the goods before the goods are sent out to the airport designated by the member for receipt, no cancellation fee will be charged for the cancellation of the goods. In such case, we will refund the reservation fee set forth under the preceding Article.`,
    article5Sentence3: `3. When a member cancels the reservation for purchasing the goods during the period after the goods are sent out to the airport designated by the member for receipt until the day before the date of receipt, a cancellation fee, the same amount of the reservation fee,  will be charged unless otherwise provided for in the goods information etc.`,
    article5Sentence4: `4. When a member does not express his/her intention to purchase the goods or cancel the reservation for purchasing the goods by the date of receipt designated at the time of reserving the goods for purchase, it is deemed that the member has canceled the reservation for the goods, and a cancellation fee, the same amount of the reservation fee, will be charged unless otherwise provided for in the goods information etc. In such case, we will appropriate the reservation fee set forth under Article 4 for the cancellation fee.`,
    article5Sentence5: `5. Even when a member does not desire to cancel the reservation, we will be entitled to cancel the reservation when we determine that the reservation made by the member through the Tax Free EC Service does not comply with laws and regulations etc., or is reasonably considered as inappropriate. The cancellation fee and refund in such case will be in accordance with the preceding paragraphs.`,
    article6: `Article 6 Conclusion of Sale and Purchase Agreement, Fixing of Price of Goods and Delivery`,
    article6Sentence1: `1. Receive at our counter\n<br/>\nWhen, on the date of receipt designated by a member at the time of reserving the goods for purchase, the member visits our counter at the airport designated by the member at the time of such reservation, during the business hours of our counter, and expresses to us his/her intention to purchase the reserved goods, and completes the procedure for purchase designated by us, a sale and purchase agreement (the “Sale and Purchase Agreement”) will be deemed to be concluded between the member and us, and we shall deliver the goods to the member.`,
    article6Sentence2: `2. Receive at our locker\n<br/>\nWhen, on the date of receipt designated by a member at the time of reserving the goods for purchase, the member visits our locker at the airport designated by the member at the time of such reservation, and expresses his/her intention to purchase the reserved goods, and completes the procedure for purchase designated by us, the Sale and Purchase Agreement will be deemed to be concluded between the member and us, and we shall deliver the goods to the member.`,
    article6Sentence3: `3. We will appropriate the reservation fee set forth under Article 4 for the price of the goods for which the Sale and Purchase Agreement has been concluded. When there is any balance after deducting the price of the goods or cancellation fee from the reservation fee, we will refund the balance to the member.`,
    article6Sentence4: `4. When the member does not express his/her intention to purchase the good or cancel the reservation for purchasing the goods by the date of receipt designated by the member at the time of reserving the goods for purchase, we may deem that the member has cancelled the reservation for the goods. The cancellation fee in such case will be in accordance with the provisions of the preceding Article.`,
    article7: `Article 7 Compliance Requirement of the Member`,
    article7Sentence1: `1. Each of the members shall not, without our consent, copy or transmit any information acquired through the use of the Website. for any purpose other than his/her private, or provide such information for use by a third party in any manner.`,
    article7Sentence10: `(8) Failing to pay the reservation fee, cancellation fee or the price of goods, charged by us (for whatever reason);`,
    article7Sentence11: `(9) Any act of violence or nuisance to us or any third party;`,
    article7Sentence12: `(10) Making a reservation that is recognized as a reservation for the purpose of resale to others or for commercial purposes; or`,
    article7Sentence13: `(11) Any other acts that violate or may violate laws and regulations.`,
    article7Sentence14: `3. When any damage are incurred by us or any third party due to an act of the member that falls under any of the above items of the preceding paragraph, the member shall have all legal responsibilities and hold us and any third party harmless.`,
    article7Sentence15: `4. When the member expresses his/her intention to us to purchase the reserved goods while the member does not meet the requirements prescribed in laws and regulations etc. to be exempted from the payment of consumption tax in purchasing the goods, the member shall pay us the amount equivalent to the consumption tax for the goods in addition to the price of the goods.`,
    article7Sentence16: `5. When we cancel the reservation made by the member through the Tax Free EC Service in accordance with Paragraph 1 of Article 8, the member shall pay the cancellation fee as set forth in Article 5.`,
    article7Sentence17: `6. When the member is a minor, the member shall reserve the goods for purchase with the consent of his/her legal representative. When the member misrepresents the consent of the legal representative or pretends to be an adult, the member cannot cancel such act.`,
    article7Sentence2: `2. Each of the members shall not conduct any of the following acts when using the Tax Free EC Service:`,
    article7Sentence3: `(1) Transmitting or writing information by pretending to be a third party;`,
    article7Sentence4: `(2) Using the Tax Free EC Service in any manner other than that approved by us;`,
    article7Sentence5: `(3) Transmitting or writing harmful computer programs, etc., or transmitting spam mail, chain letters, junk e-mail, etc.;`,
    article7Sentence6: `(4) Any act that infringes or may infringe the copyright or other intellectual property rights of us or any third party;`,
    article7Sentence7: `(5) Any act that slanders or defames us or any third party;`,
    article7Sentence8: `(6) Disclosing to other people any information, documents, figures, etc. that are contrary to public order and morals;`,
    article7Sentence9: `(7) Registering false or incomplete information concerning the name, address, phone number, e-mail address, credit card number, etc. of the user or the member of the Tax Free EC Service, whether intentionally or not;`,
    article8: `Article 8 Breach of Compliance Requirement by the Member`,
    article8Sentence1: `1. When a member breaches the compliance requirement set forth in the preceding Article, or when we determine that any act by the member is  inappropriate for the operation of the Tax Free EC Service, we will be entitled  to have the member suspend the act and cancel the Reservation Agreement or the Sale and Purchase Agreement between the member and us, as well as to take necessary measures (including legal measures) such as stopping the member from using all services related to the Website. including the Tax Free EC Service, disqualifying him/her from membership, or making a claim for damages.`,
    article8Sentence2: `2. When it is presumed that the member breaches the compliance requirement in the preceding Article, or when we reasonably determine that any act by the member is inappropriate for the operation of the Tax Free EC Service, we may make inquiries about the details of the act to the member.`,
    article9: `Article 9 Copyright`,
    article9Sentence1: `1. Each of the members shall not use any contents provided through the Website. beyond the scope of the member’s private use prescribed in the Copyright Act without our prior consent.`,
    article9Sentence2: `2. When a member breaches the provision of this Article and a dispute occurs, the member shall resolve the dispute at his/her own cost and responsibility, and shall not damage us and any third party.`,
    mainTitle: `Terms of Use for WAmazing Tax Free EC Service`
  },
  vendor: {
    sugi: `Sugi Pharmacy Kawaguchi Tozuka Store`,
    tokyu: `Tokyu Department Store`,
    wamazing: `WAmazing Shop`
  },
  wonderCompass: {
    discoverTheCharmOfJapan: (className: string) =>
      `Everyone who participates in the trial pick-up experience event will be <span class=${className}>gifted a popular Japanese souvenir!</span>\nDiscover the charm of Japan by getting regional souvenirs from all throughout the country!`,
    justThreeMins: `Just 3 minutes`,
    location: `It is located next to Shibuya 109 in the underground passageway of Shibuya Station's Exit A2.`,
    overview: `Overview`,
    title: `Our online tax-free shop trial pick-up experience will be held through September 30, 2023!`,
    contents: {
      address: `Address: Shibuya Station B1 floor, 2 Chome-1-1 Dōgenzaka, Shibuya-ku, Tokyo`,
      period: `Period: August 1, 2023 - September 30, 2023`,
      place: `Place: WANDER COMPASS SHIBUYA`,
      time: `Hours: 10:00AM - 8:00PM`
    }
  },
  yamazakiGift: {
    period: `Eligible on orders placed between April 8 (Tue) and April 21 (Mon),\nwith pickup between May 1 (Thu) and May 31 (Sat)`,
    promotionDetails: `Take advantage of this promotion for a chance to win one of 20 bottles of Yamazaki Whisky by purchasing goods worth 30,000 yen or more and using the designated 10% off coupon code below!`,
    conditions: {
      text1: `Purchase over JPY 30,000 worth of products`,
      text2: `Use the designated 10% off coupon below (please select the coupon on the shopping cart page)`
    },
    entryBotton: {
      text1: `Registered`,
      text2: `Please enter the coupon code in the coupon code field on the shopping cart page.`,
      text3: `How to Use Coupon`,
      text4: `Click this button!`
    },
    meta: {
      title: `★ Your chance to win one of 20 bottles of Yamazaki Whisky with a purchase of 30,000 yen or more! ★`
    },
    modal: {
      title: `Thank you for your entry`
    },
    notes: {
      list1: `Only orders with a discount coupon applied will be entered into the prize draw.`,
      list2: `Coupons cannot be applied to pharmaceuticals and alcohol.`,
      list3: `You will become inelligible for the prize draw if you cancel your order after placing it.`,
      list4: `Once an order has been placed, the products, delivery time, and pick-up location cannot be changed. If you wish to make changes to your order, please cancel your order and make a new one.`,
      list5: `You will only be eligible for one prize even if you place multiple purchases during the promotion period.`,
      list6: `Each country and airline has its own restrictions and customs regulations regarding carry-on luggage, so please enter the prize draw at your own risk. Please note that we cannot take responsibility for any items brought from Japan which cannot be taken into your home country.`,
      list7: `If the product cannot be picked up due to WAmazing's responsibility, the whisky gift will be replaced with a ¥5,000 discount coupon (valid for purchases over ¥10,000; excludes medicine and alcoholic beverages) for your next purchase.\nAs for the product that originally purchased, we will either refund the amount or arrange international shipping. Our representative will contact customers later to confirm the details.`,
      list8: `This promotion may change or end without notice.`,
      list9: `WAmazing reserves the right of the final decision and interpretation of this campaign.`
    },
    prize: {
      list1: `Winners will be contacted at least three days before the delivery date.`,
      list2: `Your prize will be included with your purchases.`,
      list3: `Even if we are unable to contact you, your prize will be included in the tax-free bag along with the items you ordered.`
    }
  },
  yearEndSale: {
    metaDescription: `[Up to 20% OFF] A wide variety of special products for the year-end and New Year's holidays!!`,
    metaTitle: `Year-End & New Year's Celebration!`,
    popularProductsTitle: `Recommended Popular Products`,
    startShopping: `Check out our popular products now!`
  }
} as const;
